import { Component, OnInit } from '@angular/core';
import { AbstractControl, FormArray, FormBuilder, FormControl, FormGroup, ValidationErrors, Validators } from '@angular/forms';
import { ConnectionService } from 'src/app/services/connection.service';
import { DataFieldsService } from 'src/app/services/data-fields.service';
import { ActivatedRoute } from '@angular/router';
import { ToastService } from 'src/app/services/toast.service';
import { DatePipe } from '@angular/common';
import { StorageService } from 'src/app/services/storage.service';
import { LoaderService } from 'src/app/services/loader.service';

@Component({
  selector: 'app-star-proposal-form',
  templateUrl: './star-proposal-form.page.html',
  styleUrls: ['./star-proposal-form.page.scss'],
})
export class StarProposalFormPage implements OnInit {
  proposerFilled = "section-btn active-section-btn";
  lifeAssuredFilled = "section-btn";
  illnessFilled = "section-btn";
  insurerFilled = "section-btn";
  nomineeFilled = "section-btn";
  appointeeFilled = "section-btn";
  EIADetailsfilled = "section-btn";
  disableFormSegmentBtns: boolean = true;
  insurerDetailShow: boolean = false;
  nomineeDetailShow: boolean = false;
  appointeeDetailShow: boolean = false;
  socialStatus: boolean = false;
  proposerDetails: boolean = true;
  IfShowSocialStatusYes: boolean = false;
  occupationList: any = [];
  starProposalFormDetails: FormGroup;
  starIllnessandSocialStatus: FormGroup;
  starInsurerFormDetails: FormGroup;
  starNomineeFormDetails: FormGroup;
  starAppointeeFormDetails: FormGroup;
  getCtyCode: any;
  getAreaCode: any;
  showPermAdd: boolean = true;
  productName: any;
  productRoute: string;
  quoteId: any;
  orderId: any;
  age: number;
  appointeesAge: any;
  appByDobAge: number;
  showNomineeAdd: boolean = false;
  nomineePercentage: any;
  getProposalDetails: any;
  areaId: any;
  permenantAreaId: any;
  getInsurerCount: any;
  insurers: any = [];
  nominee: any = [];
  criticalValue: number;
  inCompleteApplicationData: any;
  socialStatusBplValue: number;
  physicalyDisable: number;
  informalSector: number;
  unorgSector: number;
  premediInsurance: any;
  installment: number;
  installmentType: number;
  relationList: any = [];
  showForMediclassic: boolean;
  additionalCover: any;
  starProposalData: any = [];
  upgradedQuoteResponseObj: any;
  upgradedQuoteReqObj: any;
  appIncompleteData: any;
  getInsurer: any = [];
  basicReqData: any = {
    sumInsuredId: "",
    period: 0,
    schemeId: "",
    policyTypeName: "",
    isInstallment: "",
    installmentType: ""
  }
  insuranceData: any;
  toFindNomineeAge: any;
  showSuccessMsg: boolean;
  showErrorMsg: boolean;
  redirectUrl: any;
  errorDetails: any;
  showAppointee: boolean;
  nomineesAge: number;
  nomineeDobYear: number;
  appointeeDobYear: number;
  nomineeObj: any;
  appionteeObj: any;
  hospitalCashField: number;
  showForComprehensive: boolean;
  healthQuestion: any;
  showIfpreMedi: boolean;
  criticalIllness: any;
  hospitalCashIfTrue: boolean;
  sumInsuredId: number;
  getPermCtyCode: any;
  permCityList: any;
  cityList: any;
  areaList: any;
  permAreaList: any;
  getPermAreaCode: any;
  illnessDetail: any;
  affectedShow: boolean;
  filteredList: any = [];
  manualLabour: any;
  winterSport: any;
  showError: any;
  totalprp: any;
  buyPed: number;
  important: boolean;
  insurerArray: any = [];
  sumInsuredCol: any = [];
  findSum: any = [];
  tpInstallment: any;
  tpInstallmentType: any;
  sumId: any;
  policyPeriod: any;
  schemeId: any;
  surplus: boolean;
  termPeriod: any;
  topUpIns: any;
  getResponseParam: any;
  getIncompleteResponseParam: any;
  starCkycRefNumber: any;
  constructor(private _data: DataFieldsService, private strg: StorageService, private _datePipe: DatePipe, private toast: ToastService, private fb: FormBuilder, private apiService: ConnectionService, private route: ActivatedRoute, private loader: LoaderService) {
   }

  get nomineeGroup() {
    return this.starNomineeFormDetails.get('nomineeDetails') as FormArray;
  }

  ngOnInit() {
   // this.route.queryParamMap.subscribe((param: any) => this.topUpIns = param.params.data);
    this.route.params.subscribe(
      (params) => {
        let productName=String(params.productName)
        if(productName === 'ssi'){
          this.productRoute="Super Surplus Individual";
        }
        else{
          this.productRoute="Super Surplus Floater"
        }
      }
    );
    this.starProposalFormDetails = this.fb.group({
      star_prpName: ['', [Validators.required]],
      star_prpEmail: ['', [Validators.required, Validators.pattern('^[a-zA-Z0-9_+&*-]+(?:\\.+[a-zA-Z0-9_+&*-]+)*@+(?:[a-zA-Z0-9-]+\\.)+[a-zA-Z]{2,4}$')]],
      star_prpMobile: ['', [Validators.required, Validators.pattern('[6-9]\\d{9}')]],
      star_prpadd1: ['', [Validators.required]],
      star_prpadd2: ['', [Validators.required]],
      star_prpPin: ['', [Validators.required]],
      star_prpCity: ['', [Validators.required]],
      star_prpArea: ['', [Validators.required]],
      star_areaId: [''],
      star_prpPrmAdd1: [''],
      star_prpPrmAdd2: [''],
      star_prpPrmPin: [''],
      star_permAreaId: [''],
      star_prpPrmCity: ['', [Validators.required]],
      star_prpPrmArea: ['', [Validators.required]],
      star_prpDob: ['', [Validators.required, dobValidate]],
      star_prpPan: [''],
      star_prpGstType: [''],
      star_prpGstNumber: [''],
      star_prpAdhrNumber: [''],
      star_prpAccNumber: [''],
      star_prpIncome: [''],
    })

    this.starIllnessandSocialStatus = this.fb.group({
      star_socialStus: ['', [Validators.required]],
      star_criticIllness: ['', [Validators.required]],
      star_socialBpl: [false],
      star_physDisabled: [false],
      star_informalSector: [false],
      star_unOrgSect: [false],
      star_preMediInsurance: [''],
      star_preMediIfYes: [''],
      star_insuranceOther: [false],
    })

    this.starInsurerFormDetails = this.fb.group({
      insurerDetails: new FormArray([])
    })
    this.starNomineeFormDetails = this.fb.group({
      nomineeDetails: new FormArray([])
    })
    this.starAppointeeFormDetails = this.fb.group({
      appointeeDetails: new FormArray([])
    })

    this.route.params.subscribe(params => {
      this.productName = params['productName'];
      console.log('this.productName this.productName',this.productName)
      if (this.productName == "fho") {
        this.productRoute = "Family Health Optima";
        this.relationList = this._data.getFhoRelationsList();
      } else if (this.productName == "mci") {
        this.productRoute = "Medi-Classic Individual";
        this.relationList = this._data.getMediClassicRelationList();
        this.showForMediclassic = true;
      } else if (this.productName == "rcf") {
        this.productRoute = "Red Carpet Floater";
        this.relationList = this._data.getRedCarpetRelationShip();
      } else if (this.productName == "rci") {
        this.relationList = this._data.getRedCarepetIndividualRelationList();
        this.productRoute = "Red Carpet Individual";
      } else if (this.productName == "compi") {
        this.productRoute = "Comprehensive Individual";
        this.showForComprehensive = true;
        this.relationList = this._data.getComprehensiveIndividualRelationList();
      } else if (this.productName == "compf") {
        this.productRoute = "Comprehensive Floater";
        this.relationList = this._data.getFhoRelationsList();
        this.showForComprehensive = true;
      } else if (this.productName == "ysf") {
        this.productRoute = "Young Star Floater";
        this.relationList = this._data.getYoungStartRelation();
      } else if (this.productName == "ysi") {
        this.productRoute = "Young Star Individual";
        this.relationList = this._data.getYoungStarIndividualRelation();
      } else if (this.productName == "ssi" || this.productName == "ssf") {
        this.relationList = this._data.getYoungStartRelation();
        this.surplus = true;
      }
    });

    // this.getQuoteResId()
    this.occupationList = this._data.getStarOccupationList()
    // let today=new Date()

    var d = new Date();

    d.setDate(d.getDate() - 1);

    d.toLocaleString()
    let dd = d.getDate()
  }

  getPrprAge(event) {
    const qt_dob: string = event.target.value;
    const today = new Date();
    let dobInput = new Date(qt_dob);
    let age = today.getFullYear() - dobInput.getFullYear();
    if (age <= 100) {
      this.starInsurerFormDetails.controls.insurerDetails.value.forEach(element => {
        if (this.productRoute === "Red Carpet Floater" && element.star_prpRelName === 'Self' || this.productRoute === "Red Carpet Individual" && element.star_prpRelName === 'Self') {
          if (age < 60 || age > 75) {
            this.starProposalFormDetails.get('star_prpDob').setValue(null)
            this.toast.showToast("Age limit for this product between 60-75")
          }
        }
        if (this.productRoute === "Young Star Floater" && age > 40 && element.star_prpRelName === 'Self' || this.productRoute === "Young Star Individual" && age > 40 && element.star_prpRelName === 'Self') {
          this.starProposalFormDetails.get('star_prpDob').setValue(null)
          this.toast.showToast("Age limit upto 40 only")
        }
        if (this.productRoute === "Super Surplus Individual" || this.productRoute === "Super Surplus Floater") {
          if (age < 18 || age > 65) {
            this.starProposalFormDetails.get('star_prpDob').setValue(null)
            this.toast.showToast("Age limit for this product between 18-65")
          }
        }

      });
    }
  }

  getInsurerAge(event, i) {
    const qt_dob: string = event.target.value;
    const today = new Date();
    let dobInput = new Date(qt_dob);
    if (dobInput.getFullYear() > 1900) {
      let age = today.getFullYear() - dobInput.getFullYear();
      let day1 = new Date(qt_dob);
      let day2 = new Date();
      let time = day2.getTime() - day1.getTime();
      let dayCount = time / (1000 * 3600 * 24); //Diference in Days.
      if (age <= 100) {
        if (this.productRoute === "Red Carpet Floater" || this.productRoute === "Red Carpet Individual") {
          if (age < 60 || age > 75) {
            this.starInsurerFormDetails.controls.insurerDetails['controls'][i].controls.star_prpInsurerDob.setValue(null)
            this.toast.showToast("Age limit for this product between 60-75")
          }
        }
      }
      if (this.productRoute === "Young Star Floater" && age > 40 || this.productRoute === "Young Star Individual" && age > 40) {
        this.starInsurerFormDetails.controls.insurerDetails['controls'][i].controls.star_prpInsurerDob.setValue(null)
        this.toast.showToast("Age limit upto 40 only")
      }

      if (this.productRoute === "Super Surplus Individual" || this.productRoute === "Super Surplus Floater" && this.starInsurerFormDetails.controls.insurerDetails['controls'][i].controls.star_prpRelName === 'Self' || this.starInsurerFormDetails.controls.insurerDetails['controls'][i].controls.star_prpRelName === 'Spouse') {
        if (age < 18 || age > 65) {
          this.starInsurerFormDetails.controls.insurerDetails['controls'][i].controls.star_prpInsurerDob.setValue(null)
          this.toast.showToast("Age limit for this product between 18-65")
        }
      }
      else if (this.productRoute === "Super Surplus Individual" || this.productRoute === "Super Surplus Floater" && this.starInsurerFormDetails.controls.insurerDetails['controls'][i].controls.star_prpRelName.value === 'Son' || this.starInsurerFormDetails.controls.insurerDetails['controls'][i].controls.star_prpRelName.value === 'Daughter' && dayCount > 1) {
        if (dayCount < 91 || age > 25) {
          this.starInsurerFormDetails.controls.insurerDetails['controls'][i].controls.star_prpInsurerDob.setValue(null)
          this.toast.showToast("Age limit for dependent child between 91Days - 18 Years")
        }
      }
    }

  }
  getAdditionalCover(event?) {
    if (event.target.value === "true") {
      this.hospitalCashIfTrue = true
      //this.hospitalCashField=1
      if (this.basicReqData.period === 1) {
        this.additionalCover = "730";
        this.toast.showToast("730 added to your premium")
      }
      else if (this.basicReqData.period === 2) {
        this.additionalCover = "1410";
        this.toast.showToast("1410 added to your premium")
      }
      else if (this.basicReqData.period === 3) {
        this.additionalCover = "2048";
        this.toast.showToast("2048 added to your premium")
      }
    }
    else if (event.target.value === "false") {
      this.additionalCover = "";
    }
  }
  //Insurer Forms And Controls
  get insControl() {
    return this.starInsurerFormDetails.controls;
  }

  get insGroup() {
    return this.insControl.insurerDetails as FormArray
  }

  get nomineeControl() {
    return this.starNomineeFormDetails.controls
  }

  get appointeeControl() {
    return this.starAppointeeFormDetails.controls
  }

  get appointeeGroup() {
    return this.appointeeControl.appointeeDetails as FormArray
  }

  todayDate: any = new Date().toJSON().split('T')[0];

  ionViewDidEnter() {
    //console.log(this.topUpIns)
    this.starInsurerFormDetails = this.fb.group({
      insurerDetails: new FormArray([])
    })
    this.starNomineeFormDetails = this.fb.group({
      nomineeDetails: new FormArray([])
    })
    this.starAppointeeFormDetails = this.fb.group({
      appointeeDetails: new FormArray([])
    })
    let year = new Date().getFullYear() + Number(this.basicReqData.period)
    let month = new Date().getMonth() + 1
    let day = new Date().getDate()
    let uDate = new Date(`${day}/${month}/${year}`)
    let eDate = this._datePipe.transform(new Date(month + "/" + day + "/" + Number(year)), "MMMM dd, yyyy")
    this.strg.getStoreData('starFormPassed').then(res => {
      console.log(res)
      if (res) {
        this.strg.getStoreData('starRedirect').then(ress => {
          this.redirectUrl = ress;
          this.showSuccessMsg = true;
          this.showErrorMsg = false;
        })
      }
      else {
        this.strg.getStoreData('hlIncp').then(res => {
          if (res) {
            this.getIncompleteApplication()
          }
          else {
            this.getQuoteResId()
            //todo handling
          }
        })
      }
    })

    this.strg.getStoreData('starCkycRefNo').then(res => {
      this.starCkycRefNumber = res;
    });

    this.strg.getStoreData('starCkycFormData').then(res => {
      this.autoFillCkycData(res);
    }); 
  }
  autoFillCkycData(data) {
    let nameArr = data.name.split(" ");
    let name = nameArr.filter(entry => entry.trim() != '' && entry.trim() != 'Mr' && entry.trim() != 'Mrs' && entry.trim() != 'Ms' && entry.trim() != 'Miss').join(" ");
    this.starProposalFormDetails.get('star_prpName').setValue(name);
    this.starProposalFormDetails.get('star_prpDob').patchValue(data.dob);
    this.starProposalFormDetails.get('star_prpPin').setValue(data.pincode);
    this.getCityCode();
  }
  saveApplication() {

    let saveData = {
      "orderId": this.orderId,
      "applicationData": this.inCompleteApplicationData
    }
    this.apiService.saveIncompleteICICIAppData(saveData).subscribe(res => {
    }, err => {
    });
  }
  getIncompleteApplication() {
    this.loader.showLoader();
    this.apiService.getIncompleteICICIAppData().subscribe(res => {
      this.loader.hideLoader();
      if (res) {
        if (res.data.length != 0) {
          // let data = res.data.reverse();
          let data = res.data;
          data = data[0];
          console.log('data',data)
          this.insuranceData = JSON.parse(data.insuranceOrderHistory.insuranceQuoteResponse.insuranceQuoteRequest.reqParam)
          this.getIncompleteResponseParam = JSON.parse(data.insuranceOrderHistory.insuranceQuoteResponse.responseParam)
          this.totalprp = JSON.parse(data.parameter)
          if (this.getIncompleteResponseParam?.totalPremium >= 100000) {
            this.important = true;
            this.starProposalFormDetails.get('star_prpPan').setValidators([Validators.required, Validators.pattern("^([a-zA-Z]){3}([cptfhCPTFH]){1}([a-zA-Z]){1}([0-9]){4}([a-zA-Z]){1}?$")])
            this.starProposalFormDetails.get('star_prpPan').updateValueAndValidity()
          }
          else {
            this.starProposalFormDetails.get('star_prpPan').clearValidators()
            this.starProposalFormDetails.get('star_prpPan').updateValueAndValidity()
          }
          if (!this.surplus) {
            this.basicReqData.schemeId = this.insuranceData.starHealthQuoteRequest.schemeId
            this.basicReqData.sumInsuredId = this.insuranceData.starHealthQuoteRequest.sumInsuredId;
            this.basicReqData.policyTypeName = this.insuranceData.starHealthQuoteRequest.policyTypeName;
            this.basicReqData.installmentType = this.insuranceData.starHealthQuoteRequest.installmentType;
            this.basicReqData.isInstallment = this.insuranceData.starHealthQuoteRequest.isInstallment;
            this.basicReqData.period = this.insuranceData.starHealthQuoteRequest.period;
            this.insuranceData.starHealthQuoteRequest.insureds.forEach(element => {
              if (element.sumInsuredId) {
                this.sumInsuredId = element.sumInsuredId
              }
              else {
                this.sumInsuredId = this.basicReqData.sumInsuredId
              }
              if (element.rel === 'Father' || element.rel === 'Mother') {
                this.filteredList = this.relationList.find(item => item.relation === 'Dependent Parent')
              }
              else if (this.productName == "fho" && element.rel === 'Father-in-Law' || this.productName == "fho" && element.rel === 'Mother-in-Law') {
                this.filteredList = this.relationList.find(item => item.relation === 'Parent in Law')
              }
              else if (this.productName == "fho" && element.rel === 'Father-in-Law' && element.rel === 'Mother-in-Law') {
                this.filteredList = this.relationList.find(item => item.relation === 'Parent in Law')
              }
              else if (this.productName == "rcf" && element.rel === 'Father-in-Law' || this.productName == "rcf" && element.rel === 'Mother-in-Law') {
                this.filteredList = this.relationList.find(item => item.relation === 'Parents in Law')
              }
              else if (this.productName == "rcf" && element.rel === 'Father-in-Law' && element.rel === 'Mother-in-Law') {
                this.filteredList = this.relationList.find(item => item.relation === 'Parents in Law')
              }
              else if (this.productName == "compf" && element.rel === 'Father-in-Law' || this.productName == "compf" && element.rel === 'Mother-in-Law') {
                this.filteredList = this.relationList.find(item => item.relation === 'Parent in Law')
              }
              else if (this.productName == "compf" && element.rel === 'Father-in-Law' && element.rel === 'Mother-in-Law') {
                this.filteredList = this.relationList.find(item => item.relation === 'Parent in Law')
              }
              else if (element.rel === 'Son' || element.rel === 'Daughter' || element.rel === 'GrandSon' || element.rel === 'GrandDaughter') {
                this.filteredList = this.relationList.find(item => item.value === 3)
              }
              else {
                this.filteredList = this.relationList.find(item => item.relation === element.rel)
              }
              let customValidate;
              if (element.rel === 'Son' || element.rel === 'Daughter' || element.rel === "GrandSon" || element.rel === "GrandDaughter" || element.rel === "Nephew" || element.rel === "Niece") {
                customValidate = dobValidate2;
              } else {
                customValidate = dobValidate;
              }

              this.insGroup.push(this.fb.group({
                star_prpSumInsured: [this.sumInsuredId],
                star_prpRelName: [element.rel],
                star_prpInsurerName: [element.star_prpInsurerName, [Validators.required]],
                star_prpInsurerDob: [element.star_prpInsurerDob, [Validators.required, customValidate]],
                star_prpInsurerSex: [element.star_prpInsurerSex, [Validators.required]],
                star_prpHealthProblems: [element.star_prpHealthProblems, [Validators.required]],
                star_prpDiabetes: [element.star_prpDiabetes],
                star_prpHypertension: [element.star_prpHypertension],
                star_prpIfIllness: [element.star_prpIfIllness],
                star_prpInsurerIllness: [element.star_prpInsurerIllness],
                star_prpOccup: [element.star_prpOccup, [Validators.required]],
                star_hospitalCash: [element.star_hospitalCash],
                star_personalAccident: [element.star_personalAccident],
                star_manualLabour: [element.star_manualLabour],
                star_prpInsurerManualLabour: [element.star_prpInsurerManualLabour],
                star_prpInsurerSport: [element.star_prpInsurerSport],
                star_winterSport: [element.star_winterSport],
                star_buyBackPed: [element.star_buyBackPed],
                star_prpInsurerRelation: [this.filteredList?.value, [Validators.required]],
                star_prpHeight: [element.star_prpHeight],
                star_prpWeight: [element.star_prpWeight],
              }))
            });

          }
          else if (this.surplus) {
            console.log(this.insuranceData)
            this.basicReqData.schemeId = this.insuranceData.reqParam.schemeId;
            this.termPeriod = this.insuranceData.reqParam.policyTerm;
            this.insurerArray = this.insuranceData.reqParam.membersArray;
            this.tpInstallment = this.insuranceData.reqParam.isInstallment;
            this.tpInstallmentType = this.insuranceData.reqParam.installmentType;
            this.schemeId = this.insuranceData.reqParam.schemeId;
            this.insurerArray.forEach(element => {
              if (this.insuranceData.reqParam.policyType === 'Individual') {
                this.productName = 'SUPERSURPLUS'
                this.sumInsuredId = this.insuranceData.serverQuoteObj.insureds.sumInsuredId;
                this.sumId = this.insuranceData.serverQuoteObj.insureds.sumInsuredId;
              }
              else if (this.insuranceData.reqParam.policyType === 'Floater') {
                this.productName = 'SUPERSURPLUSFMLY'
                this.sumInsuredId = this.insuranceData.serverQuoteObj.sumInsuredId;
                this.sumId = this.insuranceData.serverQuoteObj.sumInsuredId;
              }
              if (element.memberType === 'Son' || element.memberType === 'Daughter' || element.memberType === 'GrandSon' || element.memberType === 'GrandDaughter') {
                this.filteredList = this.relationList.find(item => item.value === 3)
              }
              else {
                this.filteredList = this.relationList.find(item => item.relation === element.memberType)
              }
              element.rel = element.memberType
              let customValidate;
              if (element.memberType === 'Son' || element.memberType === 'Daughter' || element.memberType === "GrandSon" || element.memberType === "GrandDaughter" || element.memberType === "Nephew" || element.memberType === "Niece") {
                customValidate = dobValidate2;
              } else {
                customValidate = dobValidate;
              }
              this.insGroup.push(this.fb.group({
                star_prpSumInsured: [this.sumInsuredId],
                star_prpRelName: [element.rel],
                star_prpInsurerName: [element.star_prpInsurerName, [Validators.required]],
                star_prpInsurerDob: [element.star_prpInsurerDob, [Validators.required, customValidate]],
                star_prpInsurerSex: [element.star_prpInsurerSex, [Validators.required]],
                star_prpHealthProblems: [element.star_prpHealthProblems, [Validators.required]],
                star_prpDiabetes: [element.star_prpDiabetes],
                star_prpHypertension: [element.star_prpHypertension],
                star_prpIfIllness: [element.star_prpIfIllness],
                star_prpInsurerIllness: [element.star_prpInsurerIllness],
                star_prpOccup: [element.star_prpOccup, [Validators.required]],
                star_hospitalCash: [element.star_hospitalCash],
                star_personalAccident: [element.star_personalAccident],
                star_manualLabour: [element.star_manualLabour],
                star_prpInsurerManualLabour: [element.star_prpInsurerManualLabour],
                star_prpInsurerSport: [element.star_prpInsurerSport],
                star_winterSport: [element.star_winterSport],
                star_buyBackPed: [element.star_buyBackPed],
                star_prpInsurerRelation: [this.filteredList.value, [Validators.required]],
                star_prpHeight: [element.star_prpHeight],
                star_prpWeight: [element.star_prpWeight],
              }))
            });
            this.insGroup.controls.forEach(f => {
              if (f.get('star_prpRelName').value === 'Son' || f.get('star_prpRelName').value === 'FATH' || f.get('star_prpRelName').value === 'FLAW' || f.get('star_prpRelName').value === 'GFAT' || f.get('star_prpRelName').value === 'BOTH' || f.get('star_prpRelName').value === 'GSON' || f.get('star_prpRelName').value === 'MUNC' || f.get('star_prpRelName').value === 'NEPH') {
                f.get('star_prpInsurerSex').setValue('Male')
              }
              else if (f.get('star_prpRelName').value === 'Daughter' || f.get('star_prpRelName').value === 'MOTH' || f.get('star_prpRelName').value === 'MLAW' || f.get('star_prpRelName').value === 'GMOT' || f.get('star_prpRelName').value === 'SIST' || f.get('star_prpRelName').value === 'GDAU' || f.get('star_prpRelName').value === 'NIEC') {
                f.get('star_prpInsurerSex').setValue('Female')
              }
            })
          }
          this.nomineeGroup.value.forEach(element => {
            this.toFindNomineeAge = element.nomineeAge;
          });
          this.orderId = data.insuranceOrderHistory.id;
          this.quoteId = data.insuranceOrderHistory.insuranceQuoteResponse.id
          this.upgradedQuoteResponseObj = JSON.parse(data.insuranceOrderHistory.insuranceQuoteResponse.responseParam);
          this.upgradedQuoteReqObj = JSON.parse(data.insuranceOrderHistory.insuranceQuoteResponse.insuranceQuoteRequest.reqParam);
          this.appIncompleteData = JSON.parse(data.parameter);
          this.autoFillFormData(this.appIncompleteData);
          if (!this.appIncompleteData.nomineeDetails) {
            this.nomineeGroup.push(this.fb.group({
              nomineeName: ['', [Validators.required]],
              nomineeAge: ['', [Validators.required]],
              nomineeRelationship: ['', [Validators.required]],
              nomineePercentClaim: ['', [Validators.required]],
            }))
          }
          if (this.appIncompleteData.nomineeDetails) {
            this.appIncompleteData.nomineeDetails.nomineeDetails.forEach(element => {
              this.nomineeGroup.push(this.fb.group({
                nomineeName: [element.nomineeName],
                nomineeAge: [element.nomineeAge],
                nomineeRelationship: [element.nomineeRelationship],
                nomineePercentClaim: [element.nomineePercentClaim],
              }))
            });
          }
          if (this.appIncompleteData?.appointeeDetails?.appointeeDetails?.length > 0) {
            this.showAppointee = true;
            this.appIncompleteData.appointeeDetails.appointeeDetails.forEach(element => {
              this.appointeeGroup.push(this.fb.group({
                appointeeName: [element.appointeeName],
                appointeeAge: [element.appointeeAge],
                appointeeRelationship: [element.appointeeRelationship]
              }))
            });
          }
          const qt_dob: string = this.toFindNomineeAge;
          const today = new Date();
          let dobInput = new Date(qt_dob);
          let age = today.getFullYear() - dobInput.getFullYear();
          this.age = age
          if (this.nomineesAge < 18) {
            this.showAppointee = true;
          }
        }
        else {
          this.getQuoteResId();
        }
      }
    }, err => {
      this.loader.hideLoader();
    });
  }
  indexff: any;
  accordionClick(i) {
    if (i === this.indexff) {
      this.indexff = null;
    }
    else {
      this.indexff = i;
    }
  }
  autoFillFormData(autoFillData) {
    console.log('autoFillData',autoFillData)
    if (autoFillData.proposerDetails) {
      this.starProposalFormDetails.setValue(autoFillData.proposerDetails)
      this.getCityCode();
      this.getArea()
      this.getPermCityCode();
      this.getPermArea()
      this.getPermValue();
      this.getValue();
    }
    if (autoFillData.insurerDetails) {
      this.insGroup.setValue(autoFillData.insurerDetails.insurerDetails)
    }
    if (autoFillData.illnessDetails) {
      this.starIllnessandSocialStatus.setValue(autoFillData.illnessDetails)
      this.showDesc()
    }
    if (autoFillData.appointeeDetails && this.nomineesAge < 18) {
      this.appointeeGroup.setValue(autoFillData.appointeeDetails.appointeeDetails)
    }
  }
  getCityCode(e?) {
    let code = (this.starProposalFormDetails.get('star_prpPin').value)
    if (code.length === 6) {
      this.apiService.getStarCityCode(Number(code)).subscribe(res => {
        this.getCtyCode = JSON.parse(res.data)
        this.cityList = this.getCtyCode.city
        let citycode = this.getCtyCode.city[0].city_id
      })
    }
  }
  getArea() {
    let code = this.starProposalFormDetails.get('star_prpPin').value;
    let citycode = this.starProposalFormDetails.get('star_prpCity').value
    this.apiService.getStarAreaCode(citycode, code).subscribe(res => {
      this.getAreaCode = JSON.parse(res.data)
      this.areaList = this.getAreaCode.area
    })
  }
  
  showPedQues = false;
  healthProblem(event?, i?) {
    console.log("healthProblem",event, i)
    if (event.target.value === "1") {
      console.log("value healthproblem")
      this.showPedQues = true;
      this.starInsurerFormDetails.controls.insurerDetails['controls'][i].controls.star_prpDiabetes.setValidators(Validators.required)
      this.starInsurerFormDetails.controls.insurerDetails['controls'][i].controls.star_prpHypertension.setValidators(Validators.required)
      this.starInsurerFormDetails.controls.insurerDetails['controls'][i].controls.star_prpIfIllness.setValidators(Validators.required)
    } else { 
      this.showPedQues = false;
      this.starInsurerFormDetails.controls.insurerDetails['controls'][i].controls.star_prpDiabetes.clearValidators()
      this.starInsurerFormDetails.controls.insurerDetails['controls'][i].controls.star_prpDiabetes.updateValueAndValidity()
      this.starInsurerFormDetails.controls.insurerDetails['controls'][i].controls.star_prpHypertension.clearValidators()
      this.starInsurerFormDetails.controls.insurerDetails['controls'][i].controls.star_prpHypertension.updateValueAndValidity()
      this.starInsurerFormDetails.controls.insurerDetails['controls'][i].controls.star_prpIfIllness.clearValidators()
      this.starInsurerFormDetails.controls.insurerDetails['controls'][i].controls.star_prpIfIllness.updateValueAndValidity()
    }
  }
  otherHealthProblem(event?, i?) {
    if (event.target.value === "YES") {
      this.healthQuestion = this.starInsurerFormDetails.controls.insurerDetails['controls'][i].controls.star_prpInsurerIllness.value;
      this.starInsurerFormDetails.controls.insurerDetails['controls'][i].controls.star_prpInsurerIllness.setValidators(Validators.required)
    }
    else {
      this.healthQuestion = this.starInsurerFormDetails.controls.insurerDetails['controls'][i].controls.star_prpInsurerIllness.value;
      this.starInsurerFormDetails.controls.insurerDetails['controls'][i].controls.star_prpInsurerIllness.clearValidators()
      this.starInsurerFormDetails.controls.insurerDetails['controls'][i].controls.star_prpInsurerIllness.updateValueAndValidity()
    }
  }
  getPermCityCode(e?) {
    let code = this.starProposalFormDetails.get('star_prpPrmPin').value
    if (code.length === 6) {
      this.apiService.getStarCityCode(Number(code)).subscribe(res => {
        this.getPermCtyCode = JSON.parse(res.data)
        this.permCityList = this.getPermCtyCode.city
      })
    }
  }

  getPermArea() {
    let code = this.starProposalFormDetails.get('star_prpPrmPin').value;
    let citycode = this.starProposalFormDetails.get('star_prpPrmCity').value
    this.apiService.getStarAreaCode(citycode, code).subscribe(res => {
      this.getPermAreaCode = JSON.parse(res.data)
      this.permAreaList = this.getPermAreaCode.area
    })
  }

  validateLettersOnly(event) {
    if (!/^[a-zA-Z ]*$/g.test(event.key)) {
      return false;
    } else {
      return true;
    }
  }

  validateNumericsOnly(event) {
    var key = window.event ? event.keyCode : event.which;
    if (event.keyCode == 8 || event.keyCode == 46 || event.keyCode == 39 || event.keyCode == 9) {
      return true;
    }
    else if (key < 48 || key > 57) {
      return false;
    }
    else return true;
  }

  getValue() {
    this.starProposalFormDetails.get('star_areaId').setValue(this.starProposalFormDetails.get('star_prpArea').value)
    this.areaId = this.starProposalFormDetails.get('star_areaId').value
  }

  isPermanentSame(e) {
    console.log(e)
    if (e.detail.checked === true) {
      this.starProposalFormDetails.get('star_prpPrmAdd1').setValue(this.starProposalFormDetails.get('star_prpadd1').value)
      this.starProposalFormDetails.get('star_prpPrmAdd2').setValue(this.starProposalFormDetails.get('star_prpadd2').value)
      this.starProposalFormDetails.get('star_prpPrmPin').setValue(this.starProposalFormDetails.get('star_prpPin').value)
      this.starProposalFormDetails.get('star_prpPrmCity').setValue(this.starProposalFormDetails.get('star_prpCity').value)
      this.starProposalFormDetails.get('star_prpPrmArea').setValue(this.starProposalFormDetails.get('star_prpArea').value)
      this.starProposalFormDetails.get('star_permAreaId').setValue(this.starProposalFormDetails.get('star_areaId').value)
      this.permenantAreaId = this.areaId;
      this.showPermAdd = false;
      this.getPermCityCode();
      this.getPermArea();
      this.getPermValue();
    }
    else {
      this.showPermAdd = this.starProposalFormDetails.get('star_permAreaId').value
    }
  }

  getPermValue() {
    this.starProposalFormDetails.get('star_permAreaId').setValue(this.starProposalFormDetails.get('star_prpPrmArea').value)
    this.permenantAreaId = this.starProposalFormDetails.get('star_permAreaId').value
  }

  proceedToInsurer() {
    if (this.productName == "compi") {
      this.starInsurerFormDetails.controls.insurerDetails['controls'][0].controls.star_personalAccident.setValue("true")
    }
    this.proposerDetails = false;
    this.proposerFilled = "section-btn";
    this.illnessFilled = "section-btn";
    this.insurerFilled = "section-btn active-section-btn";
    this.nomineeFilled = "section-btn";
    this.insurerDetailShow = true;
    this.inCompleteApplicationData = {
      proposerDetails: this.starProposalFormDetails.value
    }
    this.saveApplication()
    this.strg.setStoreData('hlIncp', true)
    let findSelf = this.starInsurerFormDetails.controls.insurerDetails['controls'].filter(item => item.value.star_prpRelName === 'Self')
    if (findSelf[0].controls.star_prpRelName.value === "Self") {
      findSelf[0].controls.star_prpInsurerName.setValue(this.starProposalFormDetails.get('star_prpName').value)
      findSelf[0].controls.star_prpInsurerDob.setValue(this.starProposalFormDetails.get('star_prpDob').value)
    }
    if (this.productName === 'compi') {
      this.starInsurerFormDetails.controls.insurerDetails['controls'][0].controls.star_personalAccident.setValue('true')
      this.starInsurerFormDetails.controls.insurerDetails['controls'][0].controls.star_personalAccident.disable({ onlySelf: true })
    }
  }
  proceedToNominee() {
    if(this.showPedQues) {

    }
    this.proposerDetails = false;
    this.insurerDetailShow = false;
    this.proposerFilled = "section-btn";
    this.illnessFilled = "section-btn";
    this.insurerFilled = "section-btn";
    this.nomineeFilled = "section-btn active-section-btn";
    this.nomineeDetailShow = true;
    this.inCompleteApplicationData = {
      proposerDetails: this.starProposalFormDetails.value,
      insurerDetails: this.starInsurerFormDetails.value
    }
    this.saveApplication()
  }
  backToProposer() {
    this.insurerDetailShow = false;
    this.proposerDetails = true;
    this.proposerFilled = "section-btn active-section-btn";
    this.illnessFilled = "section-btn";
    this.insurerFilled = "section-btn";
    this.nomineeFilled = "section-btn";
  }
  getQuoteResId() {
    let dataa = {
      "productName": this.productRoute,
      "latest": true
    }
    if (!this.surplus) {
      this.apiService.getQuotesByUserId(dataa).subscribe(res => {
        this.getInsurerCount = JSON.parse(res.data[0].responseParam)
        this.quoteId = res.data[0].id
        this.getInsurer = JSON.parse(res.data[0].insuranceQuoteRequest.reqParam)

        this.getInsurer.starHealthQuoteRequest.insureds.forEach(element => {
          if (element.sumInsuredId) {
            this.sumInsuredId = element.sumInsuredId
          }
          else {
            this.sumInsuredId = this.basicReqData.sumInsuredId
          }
          if (element.rel === 'Father' || element.rel === 'Mother') {
            this.filteredList = this.relationList.find(item => item.relation === 'Dependent Parent')
          }
          else if (this.productName == "fho" && element.rel === 'Father-in-Law' || this.productName == "fho" && element.rel === 'Mother-in-Law') {
            this.filteredList = this.relationList.find(item => item.relation === 'Parent in Law')
          }

          else if (this.productName == "fho" && element.rel === 'Father-in-Law' && element.rel === 'Mother-in-Law') {
            this.filteredList = this.relationList.find(item => item.relation === 'Parent in Law')
          }
          else if (this.productName == "rcf" && element.rel === 'Father-in-Law' || this.productName == "rcf" && element.rel === 'Mother-in-Law') {
            this.filteredList = this.relationList.find(item => item.relation === 'Parents in Law')
          }
          else if (this.productName == "rcf" && element.rel === 'Father-in-Law' && element.rel === 'Mother-in-Law') {
            this.filteredList = this.relationList.find(item => item.relation === 'Parents in Law')
          }
          else if (this.productName == "compf" && element.rel === 'Father-in-Law' || this.productName == "compf" && element.rel === 'Mother-in-Law') {
            this.filteredList = this.relationList.find(item => item.relation === 'Parent in Law')
          }
          else if (this.productName == "compf" && element.rel === 'Father-in-Law' && element.rel === 'Mother-in-Law') {
            this.filteredList = this.relationList.find(item => item.relation === 'Parent in Law')
          }
          else if (element.rel === 'Son' || element.rel === 'Daughter' || element.rel === 'GrandSon' || element.rel === 'GrandDaughter') {
            this.filteredList = this.relationList.find(item => item.value === 3)
          }
          else {
            this.filteredList = this.relationList.find(item => item.relation === element.rel)
          }
          let customValidate;
          if (element.rel === 'Son' || element.rel === 'Daughter' || element.rel === "GrandSon" || element.rel === "GrandDaughter" || element.rel === "Nephew" || element.rel === "Niece") {
            customValidate = dobValidate2;
          } else {
            customValidate = dobValidate;
          }
          this.insGroup.push(this.fb.group({
            star_prpSumInsured: [this.sumInsuredId],
            star_prpRelName: [element.rel],
            star_prpInsurerName: ['', [Validators.required]],
            star_prpInsurerDob: ['', [Validators.required, customValidate]],
            star_prpInsurerSex: ['', [Validators.required]],
            star_prpHealthProblems: [''],
            star_prpDiabetes: [''],
            star_prpHypertension: [''],
            star_prpIfIllness: [''],
            star_prpInsurerIllness: [''],
            star_prpOccup: ['', [Validators.required]],
            star_hospitalCash: [''],
            star_personalAccident: [''],
            star_manualLabour: [''],
            star_prpInsurerManualLabour: [''],
            star_prpInsurerSport: [''],
            star_winterSport: [''],
            star_buyBackPed: [''],
            star_prpInsurerRelation: [this.filteredList.value, [Validators.required]],
            star_prpHeight: ['', [Validators.required]],
            star_prpWeight: ['', [Validators.required]],
          }))
        });

        this.starNomineeFormDetails = this.fb.group({
          nomineeDetails: this.fb.array([
            this.fb.group({
              nomineeName: ['', [Validators.required]],
              nomineeAge: ['', [Validators.required]],
              nomineeRelationship: ['', [Validators.required]],
              nomineePercentClaim: ['', [Validators.required]],
            })
          ])
        })
        this.getProposalDetails = res.data.pop()
        let getInstallmentDetails = JSON.parse(this.getProposalDetails.insuranceQuoteRequest.reqParam)
        this.installment = getInstallmentDetails.isInstallment;
        this.installmentType = getInstallmentDetails.installmentType;
        this.basicReqData.schemeId = getInstallmentDetails.starHealthQuoteRequest.schemeId
        this.basicReqData.sumInsuredId = getInstallmentDetails.starHealthQuoteRequest.sumInsuredId;
        this.basicReqData.policyTypeName = getInstallmentDetails.starHealthQuoteRequest.policyTypeName;
        this.basicReqData.installmentType = getInstallmentDetails.starHealthQuoteRequest.installmentType;
        this.basicReqData.isInstallment = getInstallmentDetails.starHealthQuoteRequest.isInstallment;
        if (getInstallmentDetails.starHealthQuoteRequest.period) {
          this.basicReqData.period = getInstallmentDetails.starHealthQuoteRequest.period
        }
        else {
          this.basicReqData.period = 1;
        }
        let data = {
          "quoteResponseId": this.quoteId
        }
        this.apiService.getApplicationOrderId(data).subscribe(res => {
          this.orderId = res.data.id
        })
      })
    }
    else if (this.surplus) {
      this.apiService.getQuotesByUserId(dataa).subscribe(resss => {
        this.getInsurer = JSON.parse(resss.data[0].insuranceQuoteRequest.reqParam)
        this.getResponseParam=JSON.parse(resss.data[0].responseParam)
        console.log(this.getInsurer)
        this.quoteId = resss.data[0].id
        this.termPeriod = this.getInsurer.serverQuoteObj.period
        this.insurerArray=this.getInsurer.reqParam.membersArray
        this.tpInstallment = this.getInsurer.reqParam.isInstallment
        this.tpInstallmentType = this.getInsurer.reqParam.installmentType
        this.schemeId=this.getInsurer.reqParam.schemeId;
        if (this.getInsurer.reqParam.policyType === 'Individual') {
          this.productName = 'SUPERSURPLUS'
           this.sumId = this.getInsurer.serverQuoteObj.insureds[0].sumInsuredId
        }
        else if (this.getInsurer.reqParam.policyType === 'Floater') {
          this.productName = 'SUPERSURPLUSFMLY'
          this.sumId = this.getInsurer.serverQuoteObj.sumInsuredId
        }
        if (this.getResponseParam.totalPremium >= 100000) {
          this.important = true;
          this.starProposalFormDetails.get('star_prpPan').setValidators([Validators.required, Validators.pattern("^([a-zA-Z]){3}([cptfhCPTFH]){1}([a-zA-Z]){1}([0-9]){4}([a-zA-Z]){1}?$")])
          this.starProposalFormDetails.get('star_prpPan').updateValueAndValidity()
        }
        else {
          this.starProposalFormDetails.get('star_prpPan').clearValidators()
          this.starProposalFormDetails.get('star_prpPan').updateValueAndValidity()
        }
        this.insurerArray.forEach(element => {
          console.log(this.getInsurer.serverQuoteObj.insureds[0].sumInsuredId)
          if (element.memberType === 'Son' || element.memberType === 'Daughter' || element.memberType === 'GrandSon' || element.memberType === 'GrandDaughter') {
            this.filteredList = this.relationList.find(item => item.value === 3)
          }
          else {
            this.filteredList = this.relationList.find(item => item.relation === element.memberType)
          }
          let customValidate;
          if (element.memberType === 'Son' || element.memberType === 'Daughter' || element.memberType === "GrandSon" || element.memberType === "GrandDaughter" || element.memberType === "Nephew" || element.memberType === "Niece") {
            customValidate = dobValidate2;
          } else {
            customValidate = dobValidate;
          }
          this.insGroup.push(this.fb.group({
            star_prpSumInsured: [this.sumId],
            star_prpRelName: [element.memberType],
            star_prpInsurerName: ['', [Validators.required]],
            star_prpInsurerDob: ['', [Validators.required, customValidate]],
            star_prpInsurerSex: ['', [Validators.required]],
            star_prpHealthProblems: [''],
            star_prpDiabetes: [''],
            star_prpHypertension: [''],
            star_prpIfIllness: [''],
            star_prpInsurerIllness: [''],
            star_prpOccup: ['', [Validators.required]],
            star_hospitalCash: [''],
            star_personalAccident: [''],
            star_manualLabour: [''],
            star_prpInsurerManualLabour: [''],
            star_prpInsurerSport: [''],
            star_winterSport: [''],
            star_buyBackPed: [''],
            star_prpInsurerRelation: [this.filteredList.value, [Validators.required]],
            star_prpHeight: ['', [Validators.required]],
            star_prpWeight: ['', [Validators.required]],
          }))

          this.starNomineeFormDetails = this.fb.group({
            nomineeDetails: this.fb.array([
              this.fb.group({
                nomineeName: ['', [Validators.required]],
                nomineeAge: ['', [Validators.required]],
                nomineeRelationship: ['', [Validators.required]],
                nomineePercentClaim: ['', [Validators.required]],
              })
            ])
          })
          this.insGroup.controls.forEach(f => {
            if (f.get('star_prpRelName').value === 'Son' || f.get('star_prpRelName').value === 'FATH' || f.get('star_prpRelName').value === 'FLAW' || f.get('star_prpRelName').value === 'GFAT' || f.get('star_prpRelName').value === 'BOTH' || f.get('star_prpRelName').value === 'GSON' || f.get('star_prpRelName').value === 'MUNC' || f.get('star_prpRelName').value === 'NEPH') {
              f.get('star_prpInsurerSex').setValue('Male')
            }
            else if (f.get('star_prpRelName').value === 'Daughter' || f.get('star_prpRelName').value === 'MOTH' || f.get('star_prpRelName').value === 'MLAW' || f.get('star_prpRelName').value === 'GMOT' || f.get('star_prpRelName').value === 'SIST' || f.get('star_prpRelName').value === 'GDAU' || f.get('star_prpRelName').value === 'NIEC') {
              f.get('star_prpInsurerSex').setValue('Female')
            }
          })
        })
        let period = this.getInsurer.serverQuoteObj.period
        console.log(this.getInsurer)
        if (period) {
          this.basicReqData.period = period
        }
        else {
          this.basicReqData.period = 1;
        }
        let data = {
          "quoteResponseId": this.quoteId
        }
        this.apiService.getApplicationOrderId(data).subscribe(res => {
          this.orderId = res.data.id
        })
      })
    }
  }

  addAppointee() {
    this.appointeeGroup.push(this.fb.group({
      appointeeName: ['', [Validators.required]],
      appointeeAge: ['', [Validators.required]],
      appointeeRelationship: ['', [Validators.required]]
    }))
  }

  appointeeArray = [];

  getAge(e, i) {
    if (e != "") {
      const qt_dob: string = e;
      const today = new Date();
      let dobInput = new Date(qt_dob);
      let age = today.getFullYear() - dobInput.getFullYear();
      const m = today.getMonth() - dobInput.getMonth();
      this.nomineesAge = age
      if (m < 0 || (m === 0 && today.getDate() < dobInput.getDate())) {
        age--;
      }
      if (age >= 18) {
        if (this.appointeeArray.includes(i)) {
          let ff = this.appointeeArray.indexOf(i);
          this.appointeeArray.splice(ff, 1);
          if (this.appointeeArray.length == 0) {
            this.showAppointee = false;
          }
        }
      } else {
        if (!this.appointeeArray.includes(i))
          this.appointeeArray.push(i)
        this.showAppointee = true;
      }
      this.age = age;
      this.validateAppointee();
    }
  }

  removeAppointee(index) {
    this.appointeeGroup.removeAt(index);
  }

  validateAppointee() {
    while (this.appointeeGroup.length !== 0) {
      this.appointeeGroup.removeAt(0)
    }
    this.appointeeArray.forEach(element => {
      this.addAppointee();
    });

  }

  getAppointeeAge(e, i) {
    this.appointeesAge = new Date(e.target.value)
    var timeDiff = Math.abs(Date.now() - this.appointeesAge);
    this.appByDobAge = Math.floor((timeDiff / (1000 * 3600 * 24)) / 365);
    if (this.appByDobAge < 19) {
      alert("Appointee age should be above 18 years")
      this.starAppointeeFormDetails.controls.appointeeDetails['controls'][i].controls.appointeeAge.setValue(null)
    }
  }

  calcPercentage(e) {
    this.nomineePercentage = e.target.value
    let sharePer = 0;
    this.nomineeGroup.value.forEach(ele => { sharePer += Number(ele.nomineePercentClaim) });
    if (sharePer != 100) {
      this.showNomineeAdd = true;
    }
    else if (sharePer >= 100) {
      this.showNomineeAdd = false;
    }
  }

  addNominee() {
    let sharePer = 0;
    this.nomineeGroup.value.forEach(ele => { sharePer += Number(ele.nomineePercentClaim) });
    if (sharePer >= 100) {
      this.toast.showToast("Nominee Claim-Percentage is already 100");
    } else {
      this.nomineeGroup.push(this.fb.group({
        nomineeName: ['', [Validators.required]],
        nomineeAge: ['', [Validators.required]],
        nomineeRelationship: ['', [Validators.required]],
        nomineePercentClaim: ['', [Validators.required]],
      }));
    }
  }

  removeNominee(index) {
    //todo
    this.nomineeGroup.removeAt(index);
    // this.adNominee.controls.pop()
    // this.adappointee.controls.pop()
  }

  proceedToAppointee() {
    let sharePer = 0;
    this.nomineeGroup.value.forEach(ele => {
      sharePer += Number(ele.nomineePercentClaim)
      if (sharePer == 100) {
        if (this.showAppointee) {
          this.proposerFilled = "section-btn";
          this.illnessFilled = "section-btn";
          this.insurerFilled = "section-btn";
          this.nomineeFilled = "section-btn";
          this.appointeeFilled = "section-btn active-section-btn"
          this.nomineeDetailShow = false;
          this.socialStatus = false;
          this.proposerDetails = false;
          this.insurerDetailShow = false;
          this.appointeeDetailShow = true;
        }
        else {
          this.proposerFilled = "section-btn";
          this.illnessFilled = "section-btn  active-section-btn";
          this.insurerFilled = "section-btn";
          this.nomineeFilled = "section-btn";
          this.appointeeFilled = "section-btn"
          this.nomineeDetailShow = false;
          this.socialStatus = true;
          this.proposerDetails = false;
          this.insurerDetailShow = false;
          this.appointeeDetailShow = false;
        }
      }
      else if (sharePer != 100) {
        this.toast.showToast("Nominee Claim-Percentage should be 100 in total");
      }
    });
    this.inCompleteApplicationData = {
      proposerDetails: this.starProposalFormDetails.value,
      insurerDetails: this.starInsurerFormDetails.value,
      nomineeDetails: this.starNomineeFormDetails.value
    }
    this.saveApplication()
  }

  proceedToIllness() {
    this.starNomineeFormDetails.value.nomineeDetails.forEach(element => {
      this.toFindNomineeAge = element.nomineeAge;
    });

    const qt_dob: string = this.toFindNomineeAge;
    const today = new Date();
    let dobInput = new Date(qt_dob);
    let age = today.getFullYear() - dobInput.getFullYear();
    this.age = age
    this.proposerFilled = "section-btn";
    this.illnessFilled = "section-btn active-section-btn";
    this.insurerFilled = "section-btn";
    this.nomineeFilled = "section-btn";
    this.appointeeFilled = "section-btn";
    this.nomineeDetailShow = false;
    this.socialStatus = true;
    this.proposerDetails = false;
    this.insurerDetailShow = false;
    this.appointeeDetailShow = false;

    this.inCompleteApplicationData = {
      proposerDetails: this.starProposalFormDetails.value,
      insurerDetails: this.starInsurerFormDetails.value,
      nomineeDetails: this.starNomineeFormDetails.value,
      appointeeDetails: this.starAppointeeFormDetails.value
    }
    this.saveApplication()
  }

  comprehensiveAccident(e, i) {
    if (this.productName != 'compi') {
      if (i === 0) {
        if (this.starInsurerFormDetails.controls.insurerDetails['controls'][0].controls.star_personalAccident.value === 'true') {
          this.starInsurerFormDetails.controls.insurerDetails['controls'][1].controls.star_personalAccident.setValue('false')
        }
        else if (this.starInsurerFormDetails.controls.insurerDetails['controls'][0].controls.star_personalAccident.value === 'false') {
          this.starInsurerFormDetails.controls.insurerDetails['controls'][1].controls.star_personalAccident.setValue('true')
        }
      }
      if (i === 1) {
        if (this.starInsurerFormDetails.controls.insurerDetails['controls'][1].controls.star_personalAccident.value === 'false') {
          this.starInsurerFormDetails.controls.insurerDetails['controls'][0].controls.star_personalAccident.setValue('true')
        }
        else if (this.starInsurerFormDetails.controls.insurerDetails['controls'][1].controls.star_personalAccident.value === 'true') {
          this.starInsurerFormDetails.controls.insurerDetails['controls'][0].controls.star_personalAccident.setValue('false')
        }
      }
    }
  }

  backToInsurer() {
    this.proposerFilled = "section-btn";
    this.illnessFilled = "section-btn";
    this.insurerFilled = "section-btn active-section-btn";
    this.nomineeFilled = "section-btn";
    this.nomineeDetailShow = false;
    this.socialStatus = false;
    this.proposerDetails = false;
    this.insurerDetailShow = true;
  }
  backToNominee() {
    this.proposerFilled = "section-btn";
    this.illnessFilled = "section-btn";
    this.insurerFilled = "section-btn";
    this.nomineeFilled = "section-btn active-section-btn";
    this.appointeeFilled = "section-btn"
    this.nomineeDetailShow = true;
    this.socialStatus = false;
    this.proposerDetails = false;
    this.insurerDetailShow = false;
    this.appointeeDetailShow = false;
  }

  backToAppointee() {
    if (this.showAppointee) {
      this.proposerFilled = "section-btn";
      this.illnessFilled = "section-btn";
      this.insurerFilled = "section-btn";
      this.nomineeFilled = "section-btn";
      this.appointeeFilled = "section-btn active-section-btn"
      this.nomineeDetailShow = false;
      this.socialStatus = false;
      this.proposerDetails = false;
      this.insurerDetailShow = false;
      this.appointeeDetailShow = true;
    }
    else {
      this.proposerFilled = "section-btn";
      this.illnessFilled = "section-btn  active-section-btn";
      this.insurerFilled = "section-btn";
      this.nomineeFilled = "section-btn";
      this.appointeeFilled = "section-btn"
      this.nomineeDetailShow = true;
      this.socialStatus = false;
      this.proposerDetails = false;
      this.insurerDetailShow = false;
      this.appointeeDetailShow = false;
    }
  }

  showAllStatus(e) {
    if (this.starIllnessandSocialStatus.get('star_socialStus').value === 'true') {
      this.IfShowSocialStatusYes = true;
      this.starIllnessandSocialStatus.get('star_socialBpl').setValidators(Validators.required),
        this.starIllnessandSocialStatus.get('star_physDisabled').setValidators(Validators.required),
        this.starIllnessandSocialStatus.get('star_unOrgSect').setValidators(Validators.required),
        this.starIllnessandSocialStatus.get('star_informalSector').setValidators(Validators.required)
      this.criticalValue = 1;
    }
    else {
      this.IfShowSocialStatusYes = false;
      this.starIllnessandSocialStatus.get('star_socialBpl').clearValidators(),
        this.starIllnessandSocialStatus.get('star_physDisabled').clearValidators(),
        this.starIllnessandSocialStatus.get('star_unOrgSect').clearValidators(),
        this.starIllnessandSocialStatus.get('star_informalSector').clearValidators()
      this.criticalValue = 0;
    }

  }

  submitForm() {
    this.inCompleteApplicationData = {
      proposerDetails: this.starProposalFormDetails.value,
      insurerDetails: this.starInsurerFormDetails.value,
      nomineeDetails: this.starNomineeFormDetails.value,
      illnessDetails: this.starIllnessandSocialStatus.value
    }

    this.saveApplication()
    if (this.starIllnessandSocialStatus.get('star_socialStus').value === 'true') {
      this.criticalValue = 1;
    }
    else {
      this.criticalValue = 0;
    }
    if (this.starIllnessandSocialStatus.get('star_socialBpl').value === 'true') {
      this.socialStatusBplValue = 1;
    }
    else {
      this.socialStatusBplValue = 0;
    }
    if (this.starIllnessandSocialStatus.get('star_physDisabled').value === 'true') {
      this.physicalyDisable = 1;
    }
    else {
      this.physicalyDisable = 0;
    }
    if (this.starIllnessandSocialStatus.get('star_informalSector').value === 'true') {
      this.informalSector = 1;
    }
    else {
      this.informalSector = 0;
    }
    if (this.starIllnessandSocialStatus.get('star_unOrgSect').value === 'true') {
      this.unorgSector = 1;
    }
    else {
      this.unorgSector = 0;
    }
    if (this.starIllnessandSocialStatus.get('star_preMediIfYes').value === 'YES') {
      this.premediInsurance = this.starIllnessandSocialStatus.get('star_preMediInsurance').value;
    }
    else {
      this.premediInsurance = "";
    }
    if (this.starIllnessandSocialStatus.get('star_criticIllness').value === 'true') {
      this.criticalIllness = 1;
    }
    else {
      this.criticalIllness = 0;
    }

    let year = new Date().getFullYear() + Number(this.basicReqData.period)
    let month = new Date().getMonth() + 1
    var d = new Date();
    d.setDate(d.getDate() - 1);
    d.toLocaleString()
    let dd = d.getDate()
    let eDate = this._datePipe.transform(new Date(month + "/" + dd + "/" + Number(year)), "MMMM dd, yyyy")

    if (!this.surplus) {
      this.starProposalData = {
        "quoteId": this.quoteId,
        "orderId": this.orderId,
        "starHealthAppSubRequest": {
          "ckycReferenceId": this.starCkycRefNumber,
          "policyTypeName": this.basicReqData.policyTypeName,
          "startOn": this._datePipe.transform(new Date(), "MMMM dd, yyyy"),
          "endOn": eDate,
          "period": this.basicReqData.period,
          "policyCategory": "fresh",
          "proposerName": this.starProposalFormDetails.get('star_prpName').value,
          "proposerEmail": this.starProposalFormDetails.get('star_prpEmail').value,
          "proposerPhone": this.starProposalFormDetails.get('star_prpMobile').value,
          "proposerDob": this._datePipe.transform(this.starProposalFormDetails.get('star_prpDob').value, "MMMM dd, yyyy"),
          "proposerAddressOne": this.starProposalFormDetails.get('star_prpadd1').value,
          "proposerAddressTwo": this.starProposalFormDetails.get('star_prpadd2').value,
          "proposerAreaId": this.areaId,
          "postalCode": this.starProposalFormDetails.get('star_prpPin').value,
          "proposerResidenceAddressOne": this.starProposalFormDetails.get('star_prpPrmAdd1').value,
          "proposerResidenceAddressTwo": this.starProposalFormDetails.get('star_prpPrmAdd2').value,
          "proposerResidenceAreaId": this.permenantAreaId,
          "proposerResidencePostalCode": this.starProposalFormDetails.get('star_prpPrmPin').value,
          "panNumber": this.starProposalFormDetails.get('star_prpPan').value.toUpperCase(),
          "gstIdNumber": this.starProposalFormDetails.get('star_prpGstNumber').value,
          "gstTypeId": this.starProposalFormDetails.get('star_prpGstType').value,
          "aadharNumber": this.starProposalFormDetails.get('star_prpAdhrNumber').value,
          "eiaNumber": this.starProposalFormDetails.get('star_prpAccNumber').value,
          "socialStatus": String(this.criticalValue),
          "socialStatusBpl": String(this.socialStatusBplValue),
          "socialStatusDisabled": String(this.physicalyDisable),
          "socialStatusInformal": String(this.informalSector),
          "socialStatusUnorganized": String(this.unorgSector),
          "previousMedicalInsurance": String(this.premediInsurance),
          "annualIncome": this.starProposalFormDetails.get('star_prpIncome').value,
          "criticalIllness": this.criticalIllness,
          "isInstallment": this.basicReqData.isInstallment,
          "installmentType": this.basicReqData.installmentType,
          "insureds": [],
          "nominees": []
        }
      }
      if (this.productRoute === 'Family Health Optima') {
        this.starProposalData.starHealthAppSubRequest.sumInsuredId = this.basicReqData.sumInsuredId;
        this.starProposalData.starHealthAppSubRequest.schemeId = this.basicReqData.schemeId;
        this.starInsurerFormDetails.controls.insurerDetails.value.forEach(element => {
          // if (element.star_prpIfIllness === 'YES') {
          //   this.illnessDetail = element.star_prpInsurerIllness
          // }
          // else {
          //   this.illnessDetail = "NONE"
          // }
          if (element.star_prpHealthProblems === '1') {
            if (element.star_prpIfIllness === 'YES') {
              this.illnessDetail = element.star_prpInsurerIllness
            }
            else {
              this.illnessDetail = "NONE"
            }
          } else {
            this.illnessDetail = "NONE"
          }
          this.insurers = {
            "name": element.star_prpInsurerName,
            "dob": this._datePipe.transform(element.star_prpInsurerDob, "MMMM dd, yyyy"),
            "sex": element.star_prpInsurerSex,
            "illness": this.illnessDetail,
            "isHealthDiseases": Number(element.star_prpHealthProblems),
            "isDiabetes": Number(element.star_prpDiabetes),
            "isHypertension": Number(element.star_prpHypertension),
            "relationshipId": Number(element.star_prpInsurerRelation),
            "occupationId": Number(element.star_prpOccup),
            "height": Number(element.star_prpHeight),
            "weight": Number(element.star_prpWeight)
          }
          this.starProposalData.starHealthAppSubRequest.insureds.push(this.insurers)
        });
        this.appionteeObj =
        {
          "appointeeName": '',
          "appointeeAge": '',
          "appointeeRelationship": ''
        }
        let appArray = []
        this.starAppointeeFormDetails.controls.appointeeDetails.value.forEach(data => {
          const qt_dob: string = data.appointeeAge;
          const today = new Date();
          let dobInput = new Date(qt_dob);
          let age = today.getFullYear() - dobInput.getFullYear();
          this.appointeeDobYear = age
          this.appionteeObj =
          {
            "appointeeName": data.appointeeName,
            "appointeeAge": String(this.appointeeDobYear),
            "appointeeRelationship": data.appointeeRelationship
          }
          appArray.push(this.appionteeObj)
        })
        let nmArray = []
        this.nomineeGroup.value.forEach(element => {
          const qt_dob: string = element.nomineeAge;
          const today = new Date();
          let dobInput = new Date(qt_dob);
          let age = today.getFullYear() - dobInput.getFullYear();
          this.nomineeDobYear = age
          this.nomineeObj =
          {
            nomineeName: element.nomineeName,
            nomineeAge: String(this.nomineeDobYear),
            nomineeRelationship: element.nomineeRelationship,
            nomineePercentClaim: element.nomineePercentClaim
          }
          nmArray.push(this.nomineeObj)
        })
        let nmnArray = nmArray.sort((a, b) => {
          return a.nomineeAge - b.nomineeAge
        })
        for (let i = 0; i < nmArray.length; i++) {
          if (nmArray.length > appArray.length) {
            appArray.push({
              "appointeeName": '',
              "appointeeAge": '',
              "appointeeRelationship": ''
            })
          }
        }

        let finalOutput = [];
        nmArray.forEach(r => {
          let indx1 = nmArray.indexOf(r);
          appArray.forEach(d => {
            let indx2 = appArray.indexOf(d);
            if (indx1 == indx2) {
              let combObj = Object.assign(r, d)
              finalOutput.push(combObj)
            }
          });
        });
        this.starProposalData.starHealthAppSubRequest.nominees = finalOutput
      }
      else if (this.productRoute === 'Medi-Classic Individual') {
        this.starInsurerFormDetails.controls.insurerDetails.value.forEach(element => {
          if (element.star_hospitalCash === 'true') {
            this.hospitalCashField = 1;
          }
          else {
            this.hospitalCashField = 0;
          }
          if (element.star_prpHealthProblems === '1') {
            if (element.star_prpIfIllness === 'YES') {
              this.illnessDetail = element.star_prpInsurerIllness
            }
            else {
              this.illnessDetail = "NONE"
            }
          } else {
            this.illnessDetail = "NONE"
          }
          this.insurers = {
            "name": element.star_prpInsurerName,
            "dob": this._datePipe.transform(element.star_prpInsurerDob, "MMMM dd, yyyy"),
            "sex": element.star_prpInsurerSex,
            "illness": this.illnessDetail,
            "isHealthDiseases": Number(element.star_prpHealthProblems),
            "isDiabetes": Number(element.star_prpDiabetes),
            "isHypertension": Number(element.star_prpHypertension),
            "sumInsuredId": element.star_prpSumInsured,
            "relationshipId": Number(element.star_prpInsurerRelation),
            "hospitalCash": this.hospitalCashField,
            "occupationId": Number(element.star_prpOccup),
            "height": Number(element.star_prpHeight),
            "weight": Number(element.star_prpWeight)
          }
          this.starProposalData.starHealthAppSubRequest.insureds.push(this.insurers)
        });
        this.appionteeObj =
        {
          "appointeeName": '',
          "appointeeAge": '',
          "appointeeRelationship": ''
        }
        let appArray = []
        this.starAppointeeFormDetails.controls.appointeeDetails.value.forEach(data => {
          const qt_dob: string = data.appointeeAge;
          const today = new Date();
          let dobInput = new Date(qt_dob);
          let age = today.getFullYear() - dobInput.getFullYear();
          this.appointeeDobYear = age
          this.appionteeObj =
          {
            "appointeeName": data.appointeeName,
            "appointeeAge": String(this.appointeeDobYear),
            "appointeeRelationship": data.appointeeRelationship
          }
          appArray.push(this.appionteeObj)
        })
        let nmArray = []
        this.nomineeGroup.value.forEach(element => {
          const qt_dob: string = element.nomineeAge;
          const today = new Date();
          let dobInput = new Date(qt_dob);
          let age = today.getFullYear() - dobInput.getFullYear();
          this.nomineeDobYear = age
          this.nomineeObj =
          {
            nomineeName: element.nomineeName,
            nomineeAge: String(this.nomineeDobYear),
            nomineeRelationship: element.nomineeRelationship,
            nomineePercentClaim: element.nomineePercentClaim
          }
          nmArray.push(this.nomineeObj)
        })

        let nmnArray = nmArray.sort((a, b) => {
          return a.nomineeAge - b.nomineeAge
        })
        for (let i = 0; i < nmArray.length; i++) {
          if (nmArray.length > appArray.length) {
            appArray.push({
              "appointeeName": '',
              "appointeeAge": '',
              "appointeeRelationship": ''
            })
          }
        }

        let finalOutput = [];
        nmArray.forEach(r => {
          let indx1 = nmArray.indexOf(r);
          appArray.forEach(d => {
            let indx2 = appArray.indexOf(d);
            if (indx1 == indx2) {
              let combObj = Object.assign(r, d)
              finalOutput.push(combObj)
            }
          });
        });
        this.starProposalData.starHealthAppSubRequest.nominees = finalOutput
      }
      else if (this.productRoute === 'Red Carpet Floater') {
        this.starProposalData.starHealthAppSubRequest.sumInsuredId = this.basicReqData.sumInsuredId;
        this.starProposalData.starHealthAppSubRequest.schemeId = this.basicReqData.schemeId;
        this.starInsurerFormDetails.controls.insurerDetails.value.forEach(element => {
          if (element.star_prpHealthProblems === '1') {
            if (element.star_prpIfIllness === 'YES') {
              this.illnessDetail = element.star_prpInsurerIllness
            }
            else {
              this.illnessDetail = "NONE"
            }
          } else {
            this.illnessDetail = "NONE"
          }
          this.insurers = {
            "name": element.star_prpInsurerName,
            "dob": this._datePipe.transform(element.star_prpInsurerDob, "MMMM dd, yyyy"),
            "sex": element.star_prpInsurerSex,
            "illness": this.illnessDetail,
            "isHealthDiseases": Number(element.star_prpHealthProblems),
            "isDiabetes": Number(element.star_prpDiabetes),
            "isHypertension": Number(element.star_prpHypertension),
            //"illnessList": element.star_prpInsurerIllness,
            "relationshipId": element.star_prpInsurerRelation,
            "occupationId": element.star_prpOccup,
            "height": Number(element.star_prpHeight),
            "weight": Number(element.star_prpWeight)
          }
          this.starProposalData.starHealthAppSubRequest.insureds.push(this.insurers)
        });
        this.appionteeObj =
        {
          "appointeeName": '',
          "appointeeAge": '',
          "appointeeRelationship": ''
        }
        let appArray = []
        this.starAppointeeFormDetails.controls.appointeeDetails.value.forEach(data => {
          const qt_dob: string = data.appointeeAge;
          const today = new Date();
          let dobInput = new Date(qt_dob);
          let age = today.getFullYear() - dobInput.getFullYear();
          this.appointeeDobYear = age
          this.appionteeObj =
          {
            "appointeeName": data.appointeeName,
            "appointeeAge": String(this.appointeeDobYear),
            "appointeeRelationship": data.appointeeRelationship
          }
          appArray.push(this.appionteeObj)
        })
        let nmArray = []
        this.nomineeGroup.value.forEach(element => {
          const qt_dob: string = element.nomineeAge;
          const today = new Date();
          let dobInput = new Date(qt_dob);
          let age = today.getFullYear() - dobInput.getFullYear();
          this.nomineeDobYear = age
          this.nomineeObj =
          {
            nomineeName: element.nomineeName,
            nomineeAge: String(this.nomineeDobYear),
            nomineeRelationship: element.nomineeRelationship,
            nomineePercentClaim: element.nomineePercentClaim
          }
          nmArray.push(this.nomineeObj)
        })

        let nmnArray = nmArray.sort((a, b) => {
          return a.nomineeAge - b.nomineeAge
        })
        for (let i = 0; i < nmArray.length; i++) {
          if (nmArray.length > appArray.length) {
            appArray.push({
              "appointeeName": '',
              "appointeeAge": '',
              "appointeeRelationship": ''
            })
          }
        }

        let finalOutput = [];
        nmArray.forEach(r => {
          let indx1 = nmArray.indexOf(r);
          appArray.forEach(d => {
            let indx2 = appArray.indexOf(d);
            if (indx1 == indx2) {
              let combObj = Object.assign(r, d)
              finalOutput.push(combObj)
            }
          });
        });
        this.starProposalData.starHealthAppSubRequest.nominees = finalOutput
      }
      else if (this.productRoute === 'Red Carpet Individual') {
        this.starInsurerFormDetails.controls.insurerDetails.value.forEach(element => {
          if (element.hospitalCash === 'true') {
            this.hospitalCashField = 1;
          }
          else {
            this.hospitalCashField = 0;
          }
          if (element.star_prpHealthProblems === '1') {
            if (element.star_prpIfIllness === 'YES') {
              this.illnessDetail = element.star_prpInsurerIllness
            }
            else {
              this.illnessDetail = "NONE"
            }
          } else {
            this.illnessDetail = "NONE"
          }
          this.insurers = {
            "name": element.star_prpInsurerName,
            "dob": this._datePipe.transform(element.star_prpInsurerDob, "MMMM dd, yyyy"),
            "sex": element.star_prpInsurerSex,
            "illness": this.illnessDetail,
            "isHealthDiseases": Number(element.star_prpHealthProblems),
            "isDiabetes": Number(element.star_prpDiabetes),
            "isHypertension": Number(element.star_prpHypertension),
            "relationshipId": Number(element.star_prpInsurerRelation),
            "occupationId": Number(element.star_prpOccup),
            "sumInsuredId": element.star_prpSumInsured,
            "height": Number(element.star_prpHeight),
            "weight": Number(element.star_prpWeight)
          }
          this.starProposalData.starHealthAppSubRequest.insureds.push(this.insurers)
        });
        this.appionteeObj =
        {
          "appointeeName": '',
          "appointeeAge": '',
          "appointeeRelationship": ''
        }
        let appArray = []
        this.starAppointeeFormDetails.controls.appointeeDetails.value.forEach(data => {
          const qt_dob: string = data.appointeeAge;
          const today = new Date();
          let dobInput = new Date(qt_dob);
          let age = today.getFullYear() - dobInput.getFullYear();
          this.appointeeDobYear = age
          this.appionteeObj =
          {
            "appointeeName": data.appointeeName,
            "appointeeAge": String(this.appointeeDobYear),
            "appointeeRelationship": data.appointeeRelationship
          }
          appArray.push(this.appionteeObj)
        })
        let nmArray = []
        this.nomineeGroup.value.forEach(element => {
          const qt_dob: string = element.nomineeAge;
          const today = new Date();
          let dobInput = new Date(qt_dob);
          let age = today.getFullYear() - dobInput.getFullYear();
          this.nomineeDobYear = age
          this.nomineeObj =
          {
            nomineeName: element.nomineeName,
            nomineeAge: String(this.nomineeDobYear),
            nomineeRelationship: element.nomineeRelationship,
            nomineePercentClaim: element.nomineePercentClaim
          }
          nmArray.push(this.nomineeObj)
        })

        let nmnArray = nmArray.sort((a, b) => {
          return a.nomineeAge - b.nomineeAge
        })
        for (let i = 0; i < nmArray.length; i++) {
          if (nmArray.length > appArray.length) {
            appArray.push({
              "appointeeName": '',
              "appointeeAge": '',
              "appointeeRelationship": ''
            })
          }
        }

        let finalOutput = [];
        nmArray.forEach(r => {
          let indx1 = nmArray.indexOf(r);
          appArray.forEach(d => {
            let indx2 = appArray.indexOf(d);
            if (indx1 == indx2) {
              let combObj = Object.assign(r, d)
              finalOutput.push(combObj)
            }
          });
        });
        this.starProposalData.starHealthAppSubRequest.nominees = finalOutput
      }
      else if (this.productRoute === 'Comprehensive Floater') {
        this.starProposalData.starHealthAppSubRequest.sumInsuredId = this.basicReqData.sumInsuredId;
        this.starProposalData.starHealthAppSubRequest.schemeId = this.basicReqData.schemeId;
        this.starInsurerFormDetails.controls.insurerDetails.value.forEach(element => {
          if (element.star_prpHealthProblems === '1') {
            if (element.star_prpIfIllness === 'YES') {
              this.illnessDetail = element.star_prpInsurerIllness
              this.buyPed = element.star_buyBackPed
            }
            else {
              this.illnessDetail = "NONE"
              this.buyPed = 0
            }
          } else {
            this.illnessDetail = "NONE"
            this.buyPed = 0
          }
          if (element.star_manualLabour === 'YES') {
            this.manualLabour = element.star_prpInsurerManualLabour
          }
          else {
            this.manualLabour = "NONE"
          }
          if (element.star_winterSport === 'YES') {
            this.winterSport = element.star_prpInsurerSport
          }
          else {
            this.winterSport = 'NONE'
          }
          this.insurers = {
            "name": element.star_prpInsurerName,
            "dob": this._datePipe.transform(element.star_prpInsurerDob, "MMMM dd, yyyy"),
            "sex": element.star_prpInsurerSex,
            "illness": this.illnessDetail,
            "isHealthDiseases": Number(element.star_prpHealthProblems),
            "isDiabetes": Number(element.star_prpDiabetes),
            "isHypertension": Number(element.star_prpHypertension),
            "relationshipId": Number(element.star_prpInsurerRelation),
            "occupationId": Number(element.star_prpOccup),
            "isPersonalAccidentApplicable": Boolean(element.star_personalAccident),
            "engageManualLabour": this.manualLabour,
            "engageWinterSports": this.winterSport,
            "height": Number(element.star_prpHeight),
            "weight": Number(element.star_prpWeight),
            "buyBackPED": this.buyPed
          }
          this.starProposalData.starHealthAppSubRequest.insureds.push(this.insurers)
        });
        this.appionteeObj =
        {
          "appointeeName": '',
          "appointeeAge": '',
          "appointeeRelationship": ''
        }
        let appArray = []
        this.starAppointeeFormDetails.controls.appointeeDetails.value.forEach(data => {
          const qt_dob: string = data.appointeeAge;
          const today = new Date();
          let dobInput = new Date(qt_dob);
          let age = today.getFullYear() - dobInput.getFullYear();
          this.appointeeDobYear = age
          this.appionteeObj =
          {
            "appointeeName": data.appointeeName,
            "appointeeAge": String(this.appointeeDobYear),
            "appointeeRelationship": data.appointeeRelationship
          }
          appArray.push(this.appionteeObj)
        })
        let nmArray = []
        this.nomineeGroup.value.forEach(element => {
          const qt_dob: string = element.nomineeAge;
          const today = new Date();
          let dobInput = new Date(qt_dob);
          let age = today.getFullYear() - dobInput.getFullYear();
          this.nomineeDobYear = age
          this.nomineeObj =
          {
            nomineeName: element.nomineeName,
            nomineeAge: String(this.nomineeDobYear),
            nomineeRelationship: element.nomineeRelationship,
            nomineePercentClaim: element.nomineePercentClaim
          }
          nmArray.push(this.nomineeObj)
        })
        let nmnArray = nmArray.sort((a, b) => {
          return a.nomineeAge - b.nomineeAge
        })
        for (let i = 0; i < nmArray.length; i++) {
          if (nmArray.length > appArray.length) {
            appArray.push({
              "appointeeName": '',
              "appointeeAge": '',
              "appointeeRelationship": ''
            })
          }
        }

        let finalOutput = [];
        nmArray.forEach(r => {
          let indx1 = nmArray.indexOf(r);
          appArray.forEach(d => {
            let indx2 = appArray.indexOf(d);
            if (indx1 == indx2) {
              let combObj = Object.assign(r, d)
              finalOutput.push(combObj)
            }
          });
        });
        this.starProposalData.starHealthAppSubRequest.nominees = finalOutput
      }
      else if (this.productRoute === 'Comprehensive Individual') {
        this.starInsurerFormDetails.controls.insurerDetails.value.forEach(element => {
          if (element.star_prpHealthProblems === '1') {
            if (element.star_prpIfIllness === 'YES') {
              this.illnessDetail = element.star_prpInsurerIllness
              this.buyPed = element.star_buyBackPed
            }
            else {
              this.illnessDetail = "NONE"
              this.buyPed = 0
            }
          } else {
            this.illnessDetail = "NONE"
            this.buyPed = 0
          }
          if (element.star_manualLabour === 'YES') {
            this.manualLabour = element.star_prpInsurerManualLabour
          }
          else {
            this.manualLabour = "NONE"
          }
          if (element.star_winterSport === 'YES') {
            this.winterSport = element.star_prpInsurerSport
          }
          else {
            this.winterSport = 'NONE'
          }
          this.insurers = {
            "name": element.star_prpInsurerName,
            "dob": this._datePipe.transform(element.star_prpInsurerDob, "MMMM dd, yyyy"),
            "sex": element.star_prpInsurerSex,
            "illness": this.illnessDetail,
            "isHealthDiseases": Number(element.star_prpHealthProblems),
            "isDiabetes": Number(element.star_prpDiabetes),
            "isHypertension": Number(element.star_prpHypertension),
            "relationshipId": Number(element.star_prpInsurerRelation),
            "occupationId": Number(element.star_prpOccup),
            "isPersonalAccidentApplicable": true,
            "engageManualLabour": this.manualLabour,
            "engageWinterSports": this.winterSport,
            "sumInsuredId": element.star_prpSumInsured,
            "height": Number(element.star_prpHeight),
            "weight": Number(element.star_prpWeight),
            "buyBackPED": this.buyPed
          }
          this.starProposalData.starHealthAppSubRequest.insureds.push(this.insurers)
        });
        this.appionteeObj =
        {
          "appointeeName": '',
          "appointeeAge": '',
          "appointeeRelationship": ''
        }
        let appArray = []
        this.starAppointeeFormDetails.controls.appointeeDetails.value.forEach(data => {
          const qt_dob: string = data.appointeeAge;
          const today = new Date();
          let dobInput = new Date(qt_dob);
          let age = today.getFullYear() - dobInput.getFullYear();
          this.appointeeDobYear = age
          this.appionteeObj =
          {
            "appointeeName": data.appointeeName,
            "appointeeAge": String(this.appointeeDobYear),
            "appointeeRelationship": data.appointeeRelationship
          }
          appArray.push(this.appionteeObj)
        })
        let nmArray = []
        this.nomineeGroup.value.forEach(element => {
          const qt_dob: string = element.nomineeAge;
          const today = new Date();
          let dobInput = new Date(qt_dob);
          let age = today.getFullYear() - dobInput.getFullYear();
          this.nomineeDobYear = age
          this.nomineeObj =
          {
            nomineeName: element.nomineeName,
            nomineeAge: String(this.nomineeDobYear),
            nomineeRelationship: element.nomineeRelationship,
            nomineePercentClaim: element.nomineePercentClaim
          }
          nmArray.push(this.nomineeObj)
        })

        let nmnArray = nmArray.sort((a, b) => {
          return a.nomineeAge - b.nomineeAge
        })
        for (let i = 0; i < nmArray.length; i++) {
          if (nmArray.length > appArray.length) {
            appArray.push({
              "appointeeName": '',
              "appointeeAge": '',
              "appointeeRelationship": ''
            })
          }
        }

        let finalOutput = [];
        nmArray.forEach(r => {
          let indx1 = nmArray.indexOf(r);
          appArray.forEach(d => {
            let indx2 = appArray.indexOf(d);
            if (indx1 == indx2) {
              let combObj = Object.assign(r, d)
              finalOutput.push(combObj)
            }
          });
        });
        this.starProposalData.starHealthAppSubRequest.nominees = finalOutput
      }
      else if (this.productRoute === 'Young Star Floater') {
        this.starProposalData.starHealthAppSubRequest.sumInsuredId = this.basicReqData.sumInsuredId;
        this.starProposalData.starHealthAppSubRequest.schemeId = this.basicReqData.schemeId;
        this.starInsurerFormDetails.controls.insurerDetails.value.forEach(element => {
          if (element.star_prpIfIllness === 'YES') {
            this.illnessDetail = element.star_prpInsurerIllness
          }
          else {
            this.illnessDetail = 'NONE'
          }
          this.insurers = {
            "name": element.star_prpInsurerName,
            "dob": this._datePipe.transform(element.star_prpInsurerDob, "MMMM dd, yyyy"),
            "sex": element.star_prpInsurerSex,
            "illness": this.illnessDetail,
            // "illnessList": this.illnessDetail,
            "relationshipId": Number(element.star_prpInsurerRelation),
            "occupationId": Number(element.star_prpOccup),
            "height": Number(element.star_prpHeight),
            "weight": Number(element.star_prpWeight),
          }
          this.starProposalData.starHealthAppSubRequest.insureds.push(this.insurers)
        });
        this.appionteeObj =
        {
          "appointeeName": '',
          "appointeeAge": '',
          "appointeeRelationship": ''
        }
        let appArray = []
        this.starAppointeeFormDetails.controls.appointeeDetails.value.forEach(data => {
          const qt_dob: string = data.appointeeAge;
          const today = new Date();
          let dobInput = new Date(qt_dob);
          let age = today.getFullYear() - dobInput.getFullYear();
          this.appointeeDobYear = age
          this.appionteeObj =
          {
            "appointeeName": data.appointeeName,
            "appointeeAge": String(this.appointeeDobYear),
            "appointeeRelationship": data.appointeeRelationship
          }
          appArray.push(this.appionteeObj)
        })
        let nmArray = []
        this.nomineeGroup.value.forEach(element => {
          const qt_dob: string = element.nomineeAge;
          const today = new Date();
          let dobInput = new Date(qt_dob);
          let age = today.getFullYear() - dobInput.getFullYear();
          this.nomineeDobYear = age
          this.nomineeObj =
          {
            nomineeName: element.nomineeName,
            nomineeAge: String(this.nomineeDobYear),
            nomineeRelationship: element.nomineeRelationship,
            nomineePercentClaim: element.nomineePercentClaim
          }
          nmArray.push(this.nomineeObj)
        })

        let nmnArray = nmArray.sort((a, b) => {
          return a.nomineeAge - b.nomineeAge
        })
        for (let i = 0; i < nmArray.length; i++) {
          if (nmArray.length > appArray.length) {
            appArray.push({
              "appointeeName": '',
              "appointeeAge": '',
              "appointeeRelationship": ''
            })
          }
        }

        let finalOutput = [];
        nmArray.forEach(r => {
          let indx1 = nmArray.indexOf(r);
          appArray.forEach(d => {
            let indx2 = appArray.indexOf(d);
            if (indx1 == indx2) {
              let combObj = Object.assign(r, d)
              finalOutput.push(combObj)
            }
          });
        });
        this.starProposalData.starHealthAppSubRequest.nominees = finalOutput
      }
      else if (this.productRoute === 'Young Star Individual') {
        this.starInsurerFormDetails.controls.insurerDetails.value.forEach(element => {
          if (element.star_prpIfIllness === 'YES') {
            this.illnessDetail = element.star_prpInsurerIllness
          }
          else {
            this.illnessDetail = "NONE"
          }
          this.insurers = {
            "name": element.star_prpInsurerName,
            "dob": this._datePipe.transform(element.star_prpInsurerDob, "MMMM dd, yyyy"),
            "sex": element.star_prpInsurerSex,
            "illness": this.illnessDetail,
            "hospitalCash": element.star_hospitalCash,
            "sumInsuredId": element.star_prpSumInsured,
            "relationshipId": Number(element.star_prpInsurerRelation),
            "occupationId": Number(element.star_prpOccup),
            "height": Number(element.star_prpHeight),
            "weight": Number(element.star_prpWeight),
          }
          this.starProposalData.starHealthAppSubRequest.insureds.push(this.insurers)
        });
        this.appionteeObj =
        {
          "appointeeName": '',
          "appointeeAge": '',
          "appointeeRelationship": ''
        }
        let appArray = []
        this.starAppointeeFormDetails.controls.appointeeDetails.value.forEach(data => {
          const qt_dob: string = data.appointeeAge;
          const today = new Date();
          let dobInput = new Date(qt_dob);
          let age = today.getFullYear() - dobInput.getFullYear();
          this.appointeeDobYear = age
          this.appionteeObj =
          {
            "appointeeName": data.appointeeName,
            "appointeeAge": String(this.appointeeDobYear),
            "appointeeRelationship": data.appointeeRelationship
          }
          appArray.push(this.appionteeObj)
        })
        let nmArray = []
        this.nomineeGroup.value.forEach(element => {
          const qt_dob: string = element.nomineeAge;
          const today = new Date();
          let dobInput = new Date(qt_dob);
          let age = today.getFullYear() - dobInput.getFullYear();
          this.nomineeDobYear = age
          this.nomineeObj =
          {
            nomineeName: element.nomineeName,
            nomineeAge: String(this.nomineeDobYear),
            nomineeRelationship: element.nomineeRelationship,
            nomineePercentClaim: element.nomineePercentClaim
          }
          nmArray.push(this.nomineeObj)
        })

        let nmnArray = nmArray.sort((a, b) => {
          return a.nomineeAge - b.nomineeAge
        })
        for (let i = 0; i < nmArray.length; i++) {
          if (nmArray.length > appArray.length) {
            appArray.push({
              "appointeeName": '',
              "appointeeAge": '',
              "appointeeRelationship": ''
            })
          }
        }

        let finalOutput = [];
        nmArray.forEach(r => {
          let indx1 = nmArray.indexOf(r);
          appArray.forEach(d => {
            let indx2 = appArray.indexOf(d);
            if (indx1 == indx2) {
              let combObj = Object.assign(r, d)
              finalOutput.push(combObj)
            }
          });
        });
        this.starProposalData.starHealthAppSubRequest.nominees = finalOutput
      }
    }
    else if (this.surplus) {
      console.log(this.termPeriod)
      let year = new Date().getFullYear() + Number(this.termPeriod)
      let month = new Date().getMonth() + 1
      let day = new Date().getDate() - 1
      let uDate = new Date(`${day}/${month}/${year}`)
      let eDate = this._datePipe.transform(new Date(month + "/" + day + "/" + Number(year)), "MMMM dd, yyyy")
      this.starProposalData = {
        "quoteId": this.quoteId,
        "orderId": this.orderId,
        "starHealthTopUpAppSubRequest": {
          "ckycReferenceId": this.starCkycRefNumber,
          "policyTypeName": this.productName,
          "startOn": this._datePipe.transform(new Date(), "MMMM dd, yyyy"),
          "endOn": eDate,
          "period": Number(this.termPeriod),
          "schemeId": this.schemeId,
          "policyCategory": "fresh",
          "proposerName": this.starProposalFormDetails.get('star_prpName').value,
          "proposerEmail": this.starProposalFormDetails.get('star_prpEmail').value,
          "proposerPhone": this.starProposalFormDetails.get('star_prpMobile').value,
          "proposerDob": this._datePipe.transform(this.starProposalFormDetails.get('star_prpDob').value, "MMMM dd, yyyy"),
          "proposerAddressOne": this.starProposalFormDetails.get('star_prpadd1').value,
          "proposerAddressTwo": this.starProposalFormDetails.get('star_prpadd2').value,
          "proposerAreaId": this.areaId,
          "postalCode": this.starProposalFormDetails.get('star_prpPin').value,
          "proposerResidenceAddressOne": this.starProposalFormDetails.get('star_prpPrmAdd1').value,
          "proposerResidenceAddressTwo": this.starProposalFormDetails.get('star_prpPrmAdd2').value,
          "proposerResidenceAreaId": this.permenantAreaId,
          "proposerResidencePostalCode": this.starProposalFormDetails.get('star_prpPrmPin').value,
          "panNumber": this.starProposalFormDetails.get('star_prpPan').value.toUpperCase(),
          "gstTypeId": this.starProposalFormDetails.get('star_prpGstType').value,
          "gstIdNumber": this.starProposalFormDetails.get('star_prpGstNumber').value,
          "aadharNumber": this.starProposalFormDetails.get('star_prpAdhrNumber').value,
          "eiaNumber": this.starProposalFormDetails.get('star_prpAccNumber').value,
          "socialStatus": String(this.criticalValue),
          "socialStatusBpl": String(this.socialStatusBplValue),
          "socialStatusDisabled": String(this.physicalyDisable),
          "socialStatusInformal": String(this.informalSector),
          "socialStatusUnorganized": String(this.unorgSector),
          "previousMedicalInsurance": String(this.premediInsurance),
          "annualIncome": this.starProposalFormDetails.get('star_prpIncome').value,
          "criticalIllness": this.starIllnessandSocialStatus.get('star_criticIllness').value,//need to add
          "isInstallment": this.tpInstallment,
          "installmentType": this.tpInstallmentType,
          "insureds": [],
          "nominees": [],
        }
      }
      if (this.productRoute === 'Super Surplus Floater') {
        console.log(this.sumId)
        this.starProposalData.starHealthTopUpAppSubRequest.sumInsuredId = this.sumId
        this.starInsurerFormDetails.controls.insurerDetails.value.forEach(element => {
          if (element.star_prpIfIllness === 'YES') {
            this.illnessDetail = element.star_prpInsurerIllness
          }
          else {
            this.illnessDetail = "NONE"
          }
          this.insurers = {
            "name": element.star_prpInsurerName,
            "dob": this._datePipe.transform(element.star_prpInsurerDob, "MMMM dd, yyyy"),
            "sex": element.star_prpInsurerSex,
            "illness": this.illnessDetail,
            "relationshipId": Number(element.star_prpInsurerRelation),
            "occupationId": Number(element.star_prpOccup),
            "height": Number(element.star_prpHeight),
            "weight": Number(element.star_prpWeight)
          }
          this.starProposalData.starHealthTopUpAppSubRequest.insureds.push(this.insurers)
        });
        this.appionteeObj =
        {
          "appointeeName": '',
          "appointeeAge": '',
          "appointeeRelationship": ''
        }
        let appArray = []
        this.starAppointeeFormDetails.controls.appointeeDetails.value.forEach(data => {
          const qt_dob: string = data.appointeeAge;
          const today = new Date();
          let dobInput = new Date(qt_dob);
          let age = today.getFullYear() - dobInput.getFullYear();
          this.appointeeDobYear = age
          this.appionteeObj =
          {
            "appointeeName": data.appointeeName,
            "appointeeAge": Number(this.appointeeDobYear),
            "appointeeRelationship": data.appointeeRelationship
          }
          appArray.push(this.appionteeObj)
        })
        let nmArray = []
        this.nomineeGroup.value.forEach(element => {
          const qt_dob: string = element.nomineeAge;
          const today = new Date();
          let dobInput = new Date(qt_dob);
          let age = today.getFullYear() - dobInput.getFullYear();
          this.nomineeDobYear = age
          this.nomineeObj =
          {
            nomineeName: element.nomineeName,
            nomineeAge: Number(this.nomineeDobYear),
            nomineeRelationship: element.nomineeRelationship,
            nomineePercentClaim: element.nomineePercentClaim
          }
          nmArray.push(this.nomineeObj)
        })
        let nmnArray = nmArray.sort((a, b) => {
          return a.nomineeAge - b.nomineeAge
        })
        for (let i = 0; i < nmArray.length; i++) {
          if (nmArray.length > appArray.length) {
            appArray.push({
              "appointeeName": '',
              "appointeeAge": '',
              "appointeeRelationship": ''
            })
          }
        }

        let finalOutput = [];
        nmArray.forEach(r => {
          let indx1 = nmArray.indexOf(r);
          appArray.forEach(d => {
            let indx2 = appArray.indexOf(d);
            if (indx1 == indx2) {
              let combObj = Object.assign(r, d)
              finalOutput.push(combObj)
            }
          });
        });
        this.starProposalData.starHealthTopUpAppSubRequest.nominees = finalOutput
      }
      else if (this.productRoute === 'Super Surplus Individual') {
        console.log(this.sumId)
        
        this.starInsurerFormDetails.controls.insurerDetails.value.forEach(element => {
          if (element.star_prpIfIllness === 'YES') {
            this.illnessDetail = element.star_prpInsurerIllness
          }
          else {
            this.illnessDetail = "NONE"
          }
          console.log(this.sumId)
          this.insurers = {
            "name": element.star_prpInsurerName,
            "dob": this._datePipe.transform(element.star_prpInsurerDob, "MMMM dd, yyyy"),
            "sex": element.star_prpInsurerSex,
            "illness": this.illnessDetail,
            "sumInsuredId": this.sumId,
            "relationshipId": Number(element.star_prpInsurerRelation),
            "occupationId": Number(element.star_prpOccup),
            "height": Number(element.star_prpHeight),
            "weight": Number(element.star_prpWeight)
          }
          this.starProposalData.starHealthTopUpAppSubRequest.insureds.push(this.insurers)
        });
        this.appionteeObj =
        {
          "appointeeName": '',
          "appointeeAge": '',
          "appointeeRelationship": ''
        }
        let appArray = []
        this.starAppointeeFormDetails.controls.appointeeDetails.value.forEach(data => {
          const qt_dob: string = data.appointeeAge;
          const today = new Date();
          let dobInput = new Date(qt_dob);
          let age = today.getFullYear() - dobInput.getFullYear();
          this.appointeeDobYear = age
          this.appionteeObj =
          {
            "appointeeName": data.appointeeName,
            "appointeeAge": Number(this.appointeeDobYear),
            "appointeeRelationship": data.appointeeRelationship
          }
          appArray.push(this.appionteeObj)
        })
        let nmArray = []
        this.nomineeGroup.value.forEach(element => {
          const qt_dob: string = element.nomineeAge;
          const today = new Date();
          let dobInput = new Date(qt_dob);
          let age = today.getFullYear() - dobInput.getFullYear();
          this.nomineeDobYear = age
          this.nomineeObj =
          {
            nomineeName: element.nomineeName,
            nomineeAge: Number(this.nomineeDobYear),
            nomineeRelationship: element.nomineeRelationship,
            nomineePercentClaim: element.nomineePercentClaim
          }
          nmArray.push(this.nomineeObj)
        })
        let nmnArray = nmArray.sort((a, b) => {
          return a.nomineeAge - b.nomineeAge
        })
        for (let i = 0; i < nmArray.length; i++) {
          if (nmArray.length > appArray.length) {
            appArray.push({
              "appointeeName": '',
              "appointeeAge": '',
              "appointeeRelationship": ''
            })
          }
        }

        let finalOutput = [];
        nmArray.forEach(r => {
          let indx1 = nmArray.indexOf(r);
          appArray.forEach(d => {
            let indx2 = appArray.indexOf(d);
            if (indx1 == indx2) {
              let combObj = Object.assign(r, d)
              finalOutput.push(combObj)
            }
          });
        });
        this.starProposalData.starHealthTopUpAppSubRequest.nominees = finalOutput
      }
    }
    if (this.starIllnessandSocialStatus.get('star_criticIllness').value === 'false') {
      if (this.starIllnessandSocialStatus.get('star_socialStus').value === 'true' && (
        this.starIllnessandSocialStatus.get('star_socialBpl').value === 'true' ||
        this.starIllnessandSocialStatus.get('star_physDisabled').value === 'true' ||
        this.starIllnessandSocialStatus.get('star_informalSector').value === 'true' ||
        this.starIllnessandSocialStatus.get('star_unOrgSect').value === 'true'
      )) {
        this.submitPrpForm()
      }
      else if (this.starIllnessandSocialStatus.get('star_socialStus').value === 'false') {
        this.submitPrpForm()
      }
      else {
        this.toast.showToast('It is mandatory to select at least one choice if yes is selected for social status')
      }
    }
    else {
      this.affectedShow = true;
    }

  }

  submitPrpForm() {
    this.loader.showLoader("It may take a while. Your patience is truly appreciated");
    if (!this.surplus) {
      // this.starProposalData["ckycReferenceId"] = this.starCkycRefNumber;
      this.apiService.starSubmitApplication(this.starProposalData).subscribe(res => {
        this.loader.hideLoader();
        let data = JSON.parse(res.data);
        if (data.redirectUrl) {
          this.removeCkycRelatedStrgAfterSuccess();
          this.redirectUrl = data.redirectUrl
          this.showSuccessMsg = true;
          this.strg.setStoreData('starFormPassed', true)
          this.strg.setStoreData('starRedirect', data.redirectUrl)
          this.showErrorMsg = false;
        }
        else {
          this.loader.hideLoader();
          this.errorDetails = data.appSubRestResponse.details
          this.showSuccessMsg = false;
          this.showErrorMsg = true;
        }
      }, err => {
        this.loader.hideLoader();
        let getError
        console.log("wererer", err);
        getError = JSON.parse(err.error.message)
        if (getError.details) {
          this.showError = getError.details
        }
        else if (getError) {
          this.showError = getError.errors
        }
        this.errorDetails
        // this.errorDetails = data.appSubRestResponse.details
        this.showSuccessMsg = false;
        this.showErrorMsg = true;
      })
    }
    else if (this.surplus) {
      // this.starProposalData["ckycReferenceId"] = this.starCkycRefNumber;
      this.apiService.starTopSubmitApplication(this.starProposalData).subscribe(res => {
        this.loader.hideLoader();
        let data = res.data;
        if (data.redirectUrl) {
          this.removeCkycRelatedStrgAfterSuccess();
          this.redirectUrl = data.redirectUrl
          this.showSuccessMsg = true;
          this.strg.setStoreData('starFormPassed', true)
          this.strg.setStoreData('starRedirect', data.redirectUrl)
          this.showErrorMsg = false;
        }
        else {
          this.loader.hideLoader();
          this.errorDetails = data.appSubRestResponse.details
          this.showSuccessMsg = false;
          this.showErrorMsg = true;
        }
      }, err => {
        this.loader.hideLoader();
        let getError
        getError = JSON.parse(err.error.message)
        if (getError.details) {
          this.showError = getError.details
        }
        else if (getError) {
          this.showError = getError.errors
        }
        this.loader.hideLoader();
        this.errorDetails
        // this.errorDetails = data.appSubRestResponse.details
        this.showSuccessMsg = false;
        this.showErrorMsg = true;
      })
    }

  }

  removeCkycRelatedStrgAfterSuccess() {
    this.strg.removeStoreData("starCkycFormData");
    this.strg.removeStoreData("starProducts");
    this.strg.removeStoreData("starCkycRefNo");
  }

  backBtn() {
    this.showSuccessMsg = false;
    this.showErrorMsg = false;
    this.affectedShow = false;
  }

  proceedToPayment() {
    window.open(this.redirectUrl, "_self")
  }

  showDesc() {
    if (this.starIllnessandSocialStatus.get('star_preMediIfYes').value === 'YES') {
      this.showIfpreMedi = true;
    }
    else {
      this.showIfpreMedi = false;
    }
  }
}

function dobValidate(control: AbstractControl) {
  const qt_dob: string = control.value;
  const today = new Date();
  let dobInput = new Date(qt_dob);
  var d = new Date();
  d.setMonth(d.getMonth() - 3);
  if (dobInput < d) {
    let age = today.getFullYear() - dobInput.getFullYear();
    const m = today.getMonth() - dobInput.getMonth();
    if (m < 0 || (m === 0 && today.getDate() < dobInput.getDate())) {
      age--;
    }
    if (age < 18 || age == NaN || age > 99) {
      return { 'dobError': true };
    } else {
      return null;
    }
  } else {
    return { 'dobError': true };
  }
}

function dobValidate2(control: AbstractControl) {
  const qt_dob: string = control.value;
  const today = new Date();
  let dobInput = new Date(qt_dob);
  var d = new Date();
  // d.setMonth(d.getMonth() - 3);
  if (dobInput < d) {
    let age = today.getFullYear() - dobInput.getFullYear();
    const m = today.getMonth() - dobInput.getMonth();
    if (m < 0 || (m === 0 && today.getDate() < dobInput.getDate())) {
      age--;
    }
    if (age == NaN || age > 24) {
      return { 'dobError': true };
    } else {
      return null;
    }
  } else {
    return { 'dobError': true };
  }
}